/*! Copyright © 2009-2018 Postcode Anywhere (Holdings) Ltd. (http://www.postcodeanywhere.co.uk)
 *
 * AddressComplete v2.00
 * Capture Plus for the web.
 *
 * WEB-2-3 18/01/2018 12:33:06
 */
/* eslint-disable */

(function (n, t) {
  function e() {
    r.addEventListener
      ? (i.ignore(r, 'DOMContentLoaded', e), (f = !0), i.ready())
      : r.readyState === 'complete' &&
        (i.ignore(r, 'onreadystatechange', e), (f = !0), i.ready());
  }
  function v() {
    r.readyState === 'complete'
      ? ((f = !0), i.ready())
      : (r.addEventListener
          ? i.listen(r, 'DOMContentLoaded', e)
          : i.listen(r, 'onreadystatechange', e),
        i.listen(n, 'load', e));
  }
  function h(n) {
    var t, u, r;
    if (i.blockRequests && i.waitingRequest) {
      i.requestQueue = [n.index];
      return;
    }
    if ((n.block && (i.blockRequests = !0), n.queue && i.waitingRequest)) {
      i.requestQueue.push(n.index);
      return;
    }
    if (((i.waitingRequest = !0), n.cache))
      for (t = 0; t < i.requests.length; t++)
        if (
          i.requests[t] &&
          i.requests[t].service === n.service &&
          i.requests[t].response
        ) {
          u = !0;
          for (r in n.data)
            if (n.data[r] !== i.requests[t].data[r]) {
              u = !1;
              break;
            }
          if (u) {
            n.callback(i.requests[t].response), (i.requests[n.index] = null);
            return;
          }
        }
    n.post ? s(n) : a(n);
  }
  function y(n) {
    (i.waitingRequest = !1),
      n.block && (i.blockRequests = !1),
      n.response.Items.length === 1 && n.response.Items[0].Error !== t
        ? n.error(n.response.Items[0].Description)
        : n.success(n.response.Items),
      n.cache || (i.requests[n.index] = null),
      i.requestQueue.length && h(i.requests[i.requestQueue.shift()]);
  }
  function a(n) {
    navigator.appName == 'Microsoft Internet Explorer' ? w(n) : p(n);
  }
  function p(n) {
    var t = new XMLHttpRequest(),
      f = i.protocol + '//' + i.host + '/' + n.service + '/' + i.endpoint,
      u = '',
      r;
    for (r in n.data)
      u += (u ? '&' : '?') + r + '=' + encodeURIComponent(n.data[r]);
    (f += u),
      f.length > i.limit
        ? ((n.post = !0), s(n))
        : ((t.onreadystatechange = function () {
            t.readyState == 4 && n.callback(i.parseJSON(t.responseText));
          }),
          n.credentials && (t.withCredentials = n.credentials),
          t.open('GET', f, !0),
          t.send());
  }
  function w(n) {
    var t = i.create('script', { type: 'text/javascript', async: 'async' }),
      f = r.getElementsByTagName('head')[0],
      o = i.protocol + '//' + i.host + '/' + n.service + '/' + i.endpoint,
      u = '',
      e;
    for (e in n.data)
      u += (u ? '&' : '?') + e + '=' + encodeURIComponent(n.data[e]);
    (u += '&callback=pca.requests[' + n.index + '].callback'),
      (t.src = o + u),
      (t.onload = t.onreadystatechange = function () {
        (this.readyState &&
          this.readyState !== 'loaded' &&
          this.readyState !== 'complete') ||
          ((t.onload = t.onreadystatechange = null),
          f && t.parentNode && f.removeChild(t));
      }),
      t.src.length > i.limit
        ? ((n.post = !0), s(n))
        : f.insertBefore(t, f.firstChild);
  }
  function s(n) {
    navigator.appName == 'Microsoft Internet Explorer' ? l(n) : c(n);
  }
  function c(n) {
    var t = new XMLHttpRequest(),
      f = i.protocol + '//' + i.host + '/' + n.service + '/' + i.endpoint,
      r = '',
      u;
    for (u in n.data)
      r += (r ? '&' : '') + u + '=' + encodeURIComponent(n.data[u]);
    (t.onreadystatechange = function () {
      t.readyState == 4 && n.callback(i.parseJSON(t.responseText));
    }),
      n.credentials && (t.withCredentials = n.credentials),
      t.open('POST', f, !0),
      t.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded'),
      t.send(r);
  }
  function l(n) {
    function o(n, t) {
      var i = r.createElement('input');
      (i.name = n), (i.value = t), u.appendChild(i);
    }
    var u = r.createElement('form'),
      t = r.createElement('iframe'),
      s = !1,
      e,
      f;
    (u.method = 'POST'),
      (u.action = i.protocol + '//' + i.host + '/' + n.service + '/json.ws');
    for (e in n.data) o(e, n.data[e]);
    o('CallbackVariable', 'window.name'),
      o('CallbackWithScriptTags', 'true'),
      (t.onload = function () {
        s
          ? (n.callback({ Items: i.parseJSON(t.contentWindow.name) }),
            r.body.removeChild(t))
          : ((s = !0), (t.contentWindow.location = 'about:blank'));
      }),
      (t.style.display = 'none'),
      r.body.appendChild(t),
      (f = t.contentDocument || t.contentWindow.document),
      f.body ? f.body.appendChild(u) : f.appendChild(u),
      u.submit();
  }
  function u(t) {
    return t == n || t == r || t == r.body;
  }
  var i = (n.pca = n.pca || {}),
    r = n.document,
    f,
    o;
  (i.protocol =
    (n.location || r.location).protocol == 'https:' ? 'https:' : 'http:'),
    (i.host = 'ws1.postescanada-canadapost.ca'),
    (i.endpoint = 'json3.ws'),
    (i.limit = 2e3),
    (i.synonyms = [
      { r: /\bN(?=\s)/, w: 'NORTH' },
      { r: /\b(?:NE|NORTHEAST)(?=\s)/, w: 'NORTH EAST' },
      { r: /\b(?:NW|NORTHWEST)(?=\s)/, w: 'NORTH WEST' },
      { r: /\bS(?=\s)/, w: 'SOUTH' },
      { r: /\b(?:SE|SOUTHEAST)(?=\s)/, w: 'SOUTH EAST' },
      { r: /\b(?:SW|SOUTHWEST)(?=\s)/, w: 'SOUTH WEST' },
      { r: /\bE(?=\s)/, w: 'EAST' },
      { r: /\bW(?=\s)/, w: 'WEST' },
      { r: /\bST(?=\s)/, w: 'SAINT' },
    ]),
    (i.diacritics = [
      { r: /[ÀÁÂÃ]/gi, w: 'A' },
      { r: /Å/gi, w: 'AA' },
      { r: /[ÆæÄ]/gi, w: 'AE' },
      { r: /Ç/gi, w: 'C' },
      { r: /Ð/gi, w: 'DJ' },
      { r: /[ÈÉÊË]/gi, w: 'E' },
      { r: /[ÌÍÏ]/gi, w: 'I' },
      { r: /Ñ/gi, w: 'N' },
      { r: /[ÒÓÔÕ]/gi, w: 'O' },
      { r: /[ŒØÖ]/gi, w: 'OE' },
      { r: /Š/gi, w: 'SH' },
      { r: /ß/gi, w: 'SS' },
      { r: /[ÙÚÛ]/gi, w: 'U' },
      { r: /Ü/gi, w: 'UE' },
      { r: /[ŸÝ]/gi, w: 'ZH' },
      { r: /-/gi, w: ' ' },
      { r: /[.,]/gi, w: '' },
    ]),
    (i.hypertext = [
      { r: /&/g, w: '&amp;' },
      { r: /"/g, w: '&quot;' },
      { r: /'/g, w: '&#39;' },
      { r: /</g, w: '&lt;' },
      { r: />/g, w: '&gt;' },
    ]),
    (i.requests = []),
    (i.requestQueue = []),
    (i.waitingRequest = !1),
    (i.blockRequests = !1),
    (i.styleFixes = []),
    (i.container = null),
    (f = !1),
    (o = []),
    (i.fuzzyMatch = !0),
    (i.fuzzyTags = ['*']),
    (i.ready = function (n) {
      var i, t;
      if (f) {
        if (o.length) for (i = o, o = [], t = 0; t < i.length; t++) i[t]();
        n && n();
      } else typeof n == 'function' && o.push(n);
    }),
    (i.Eventable = function (n) {
      var t = n || this;
      return (
        (t.listeners = {}),
        (t.listen = function (n, i) {
          (t.listeners[n] = t.listeners[n] || []), t.listeners[n].push(i);
        }),
        (t.ignore = function (n, i) {
          if (t.listeners[n])
            for (var r = 0; r < t.listeners[n].length; r++)
              if (t.listeners[n][r] === i) {
                t.listeners[n].splice(r, 1);
                break;
              }
        }),
        (t.fire = function (n, i) {
          var u, f, r;
          if (t.listeners[n])
            for (u = 0; u < t.listeners[n].length; u++) {
              for (f = [i], r = 2; r < arguments.length; r++)
                f.push(arguments[r]);
              t.listeners[n][u].apply(t, f);
            }
        }),
        t
      );
    }),
    (i.Request = function (n, t, r, u) {
      var f = new i.Eventable(this);
      (f.service = n || ''),
        (f.data = t || {}),
        (f.success = r || function () {}),
        (f.error = u || function () {}),
        (f.response = null),
        (f.cache = !!f.data.$cache),
        (f.queue = !!f.data.$queue),
        (f.block = !!f.data.$block),
        (f.post = !!f.data.$post),
        (f.credentials = !!f.data.$credentials),
        (f.callback = function (n) {
          (f.response = n), y(f);
        }),
        (f.index = i.requests.length),
        i.requests.push(f);
    }),
    (i.fetch = function (n, t, r, u) {
      h(new i.Request(n, t, r, u));
    }),
    (i.loadScript = function (n, t, u) {
      var f = i.create('script', { type: 'text/javascript' }),
        e = (u || r).getElementsByTagName('head')[0];
      (f.onload = f.onreadystatechange = function () {
        (this.readyState &&
          this.readyState !== 'loaded' &&
          this.readyState !== 'complete') ||
          ((f.onload = f.onreadystatechange = null), (t || function () {})());
      }),
        (f.src =
          (~n.indexOf('/') ? '' : i.protocol + '//' + i.host + '/js/') + n),
        e.insertBefore(f, e.firstChild);
    }),
    (i.loadStyle = function (n, t, u) {
      var f = i.create('link', { type: 'text/css', rel: 'stylesheet' }),
        e = (u || r).getElementsByTagName('head')[0];
      (f.onload = f.onreadystatechange = function () {
        (this.readyState &&
          this.readyState !== 'loaded' &&
          this.readyState !== 'complete') ||
          ((f.onload = f.onreadystatechange = null), (t || function () {})());
      }),
        (f.href =
          (~n.indexOf('/') ? '' : i.protocol + '//' + i.host + '/css/') + n),
        e.insertBefore(f, e.firstChild);
    }),
    (i.Item = function (n, t) {
      var r = new i.Eventable(this),
        u = 'pcaselected';
      return (
        (r.data = n),
        (r.format = t),
        (r.html = i.formatLine(n, t)),
        (r.tag = i.formatTag(r.html)),
        (r.element = i.create('div', {
          className: 'pcaitem',
          innerHTML: r.html,
          title: i.removeHtml(r.html),
        })),
        (r.visible = !0),
        (r.highlight = function () {
          return i.addClass(r.element, u), r.fire('highlight'), r;
        }),
        (r.lowlight = function () {
          return i.removeClass(r.element, u), r.fire('lowlight'), r;
        }),
        (r.mouseover = function () {
          r.fire('mouseover');
        }),
        (r.mouseout = function () {
          r.fire('mouseout');
        }),
        (r.select = function () {
          return r.fire('select', r.data), r;
        }),
        (r.hide = function () {
          return (
            (r.visible = !1),
            (r.element.style.display = 'none'),
            r.fire('hide'),
            r
          );
        }),
        (r.show = function () {
          return (
            (r.visible = !0), (r.element.style.display = ''), r.fire('show'), r
          );
        }),
        i.listen(r.element, 'mouseover', r.mouseover),
        i.listen(r.element, 'mouseout', r.mouseout),
        i.listen(r.element, 'click', r.select),
        r
      );
    }),
    (i.Collection = function () {
      var n = new i.Eventable(this);
      return (
        (n.items = []),
        (n.selected = -1),
        (n.count = 0),
        (n.add = function (t, r, u) {
          function e(t) {
            var f = new i.Item(t, r);
            f.listen('mouseover', function () {
              n.select(f);
            }),
              f.listen('select', u),
              n.items.push(f);
          }
          if (((u = u || function () {}), t.length))
            for (var f = 0; f < t.length; f++) e(t[f]);
          else e(t);
          return (n.count += t.length), n.fire('add'), n;
        }),
        (n.sort = function (t) {
          return (
            n.items.sort(function (n, i) {
              return t
                ? n.data[t] > i.data[t]
                  ? 1
                  : -1
                : n.tag > i.tag
                ? 1
                : -1;
            }),
            n.fire('sort'),
            n
          );
        }),
        (n.reverse = function () {
          return n.items.reverse(), n.fire('reverse'), n;
        }),
        (n.filter = function (t) {
          var u = i.formatTag(t),
            r = n.count;
          return (
            (n.count = 0),
            n.all(function (t) {
              ~t.tag.indexOf(u) ? (t.show(), n.count++) : t.hide();
            }),
            r != n.count && n.fire('filter'),
            n
          );
        }),
        (n.match = function (t) {
          var u = i.formatTag(t),
            r = [];
          return (
            n.all(function (n) {
              ~n.tag.indexOf(u) && r.push(n);
            }),
            r
          );
        }),
        (n.clear = function () {
          return (
            (n.items = []), (n.count = 0), (n.selected = -1), n.fire('clear'), n
          );
        }),
        (n.all = function (t) {
          for (var i = 0; i < n.items.length; i++)
            if (t(n.items[i]) === !1) break;
          return n;
        }),
        (n.select = function (t) {
          return (
            ~n.selected && n.items[n.selected].lowlight(),
            (n.selected = n.index(t)),
            ~n.selected && n.items[n.selected].highlight(),
            n.fire('select'),
            n
          );
        }),
        (n.index = function (t) {
          for (var i = 0; i < n.items.length; i++)
            if (n.items[i] == t) return i;
          return -1;
        }),
        (n.first = function (t) {
          for (var i = 0; i < n.items.length; i++)
            if (t ? t(n.items[i]) : n.items[i].visible) return n.items[i];
          return null;
        }),
        (n.last = function (t) {
          for (var i = n.items.length - 1; i >= 0; i--)
            if (t ? t(n.items[i]) : n.items[i].visible) return n.items[i];
          return null;
        }),
        (n.next = function (t) {
          for (var i = n.selected + 1; i < n.items.length; i++)
            if (t ? t(n.items[i]) : n.items[i].visible) return n.items[i];
          return n.first();
        }),
        (n.previous = function (t) {
          for (var i = n.selected - 1; i >= 0; i--)
            if (t ? t(n.items[i]) : n.items[i].visible) return n.items[i];
          return n.last();
        }),
        n
      );
    }),
    (i.List = function () {
      var t = new i.Eventable(this);
      return (
        (t.element = i.create('div', { className: 'pca pcalist' })),
        (t.collection = new i.Collection()),
        (t.visible = !0),
        (t.scroll = {
          held: !1,
          moved: !1,
          origin: 0,
          position: 0,
          x: 0,
          y: 0,
          dx: 0,
          dy: 0,
        }),
        (t.show = function () {
          return (
            (t.visible = !0), (t.element.style.display = ''), t.fire('show'), t
          );
        }),
        (t.hide = function () {
          return (
            (t.visible = !1),
            (t.element.style.display = 'none'),
            t.fire('hide'),
            t
          );
        }),
        (t.draw = function () {
          return (
            t.destroy(),
            t.collection.all(function (n) {
              t.element.appendChild(n.element);
            }),
            t.fire('draw'),
            t
          );
        }),
        (t.add = function (n, i, r) {
          return t.collection.add(n, i, r), t.fire('add'), t.draw(), t;
        }),
        (t.destroy = function () {
          while (t.element.childNodes && t.element.childNodes.length)
            t.element.removeChild(t.element.childNodes[0]);
          return t;
        }),
        (t.clear = function () {
          return t.collection.clear(), t.destroy(), t.fire('clear'), t;
        }),
        (t.setScroll = function (n) {
          return (t.element.scrollTop = n), t.fire('scroll'), t;
        }),
        (t.enableTouch = function () {
          function f(i) {
            (i = i || n.event),
              (t.scroll.held = !0),
              (t.scroll.moved = !1),
              (t.scroll.origin = parseInt(t.scrollTop)),
              (t.scroll.y = parseInt(i.touches[0].pageY));
          }
          function e() {
            t.scroll.held = !1;
          }
          function r() {
            t.scroll.held = !1;
          }
          function u(r) {
            t.scroll.held &&
              ((r = r || n.event),
              i.smash(r),
              (t.scroll.dy = t.scroll.y - parseInt(r.touches[0].pageY)),
              (t.scroll.position = t.scroll.origin + t.scroll.dy),
              t.setScroll(t.scroll.position),
              (t.scroll.moved = !0));
          }
          return (
            i.listen(t.element, 'touchstart', f),
            i.listen(t.element, 'touchmove', u),
            i.listen(t.element, 'touchend', e),
            i.listen(t.element, 'touchcancel', r),
            t
          );
        }),
        (t.move = function (n) {
          return n && (t.collection.select(n), t.scrollToItem(n)), t;
        }),
        (t.next = function () {
          return t.move(t.collection.next());
        }),
        (t.previous = function () {
          return t.move(t.collection.previous());
        }),
        (t.first = function () {
          return t.move(t.collection.first());
        }),
        (t.last = function () {
          return t.move(t.collection.last());
        }),
        (t.select = function () {
          return (
            t.selectable() &&
              t.collection.items[t.collection.selected].select(),
            t
          );
        }),
        (t.selectable = function () {
          return t.visible && !!t.collection.items[t.collection.selected];
        }),
        (t.navigate = function (n) {
          switch (n) {
            case 40:
              return t.next(), !0;
            case 38:
              return t.previous(), !0;
            case 13:
              if (t.selectable()) return t.select(), !0;
          }
          return !1;
        }),
        (t.scrollToItem = function (n) {
          return (
            (t.scroll.position = t.element.scrollTop),
            n.element.offsetTop < t.scroll.position
              ? ((t.scroll.position = n.element.offsetTop),
                t.setScroll(t.scroll.position))
              : n.element.offsetTop + n.element.offsetHeight >
                  t.scroll.position + t.element.offsetHeight &&
                ((t.scroll.position =
                  n.element.offsetTop +
                  n.element.offsetHeight -
                  t.element.offsetHeight),
                t.setScroll(t.scroll.position)),
            t
          );
        }),
        (t.filter = function (n) {
          var i = t.collection.count;
          return (
            t.collection.filter(n),
            i != t.collection.count && t.fire('filter'),
            t
          );
        }),
        t
      );
    }),
    (i.AutoComplete = function (t, f) {
      var e = new i.Eventable(this);
      return (
        (e.options = f || {}),
        (e.element = i.create('div', { className: 'pcaautocomplete pcatext' })),
        (e.anchors = []),
        (e.list = new i.List()),
        (e.fieldListeners = []),
        (e.field = null),
        (e.positionField = null),
        (e.visible = !0),
        (e.hover = !1),
        (e.focused = !1),
        (e.controlDown = !1),
        (e.disabled = !1),
        (e.fixedWidth = !1),
        (e.emptyMessage = e.options.emptyMessage || ''),
        (e.skipFilter = !1),
        (e.header = {
          element: i.create('div', { className: 'pcaheader' }),
          headerText: i.create('div', { className: 'pcamessage' }),
          init: function () {
            this.hide();
          },
          setContent: function (n) {
            return (
              (n = n || ''),
              typeof n == 'string'
                ? (this.element.innerHTML = n)
                : this.element.appendChild(n),
              e.fire('header'),
              this
            );
          },
          setText: function (n) {
            return (
              (n = n || ''),
              this.element.appendChild(this.headerText),
              typeof n == 'string'
                ? (this.headerText.innerHTML = n)
                : this.headerText.appendChild(n),
              e.fire('header'),
              this
            );
          },
          clear: function () {
            return this.setContent(), e.fire('header'), this;
          },
          show: function () {
            return (this.element.style.display = ''), e.fire('header'), this;
          },
          hide: function () {
            return (
              (this.element.style.display = 'none'), e.fire('header'), this
            );
          },
        }),
        (e.footer = {
          element: i.create('div', { className: 'pcafooter' }),
          init: function () {
            this.hide();
          },
          setContent: function (n) {
            return (
              (n = n || ''),
              typeof n == 'string'
                ? (this.element.innerHTML = n)
                : this.element.appendChild(n),
              e.fire('footer'),
              this
            );
          },
          show: function () {
            return (this.element.style.display = ''), e.fire('footer'), this;
          },
          hide: function () {
            return (
              (this.element.style.display = 'none'), e.fire('footer'), this
            );
          },
        }),
        (e.load = function () {
          if (t.length && t.constructor == Array)
            for (var n = 0; n < t.length; n++) e.attach(i.getElement(t[n]));
          else e.attach(i.getElement(t));
          return (
            i.listen(e.element, 'mouseover', function () {
              e.hover = !0;
            }),
            i.listen(e.element, 'mouseout', function () {
              e.hover = !1;
            }),
            i.listen(r, 'click', e.checkHide),
            ((r.documentMode && r.documentMode <= 7) ||
              /\bMSIE (7|6)/.test(navigator.userAgent)) &&
              e.setWidth(280),
            r.documentMode &&
              r.documentMode <= 5 &&
              (i.applyStyleFixes('.pca .pcafooter', { fontSize: '0pt' }),
              i.applyStyleFixes('.pca .pcaflag', { fontSize: '0pt' })),
            e
          );
        }),
        (e.attach = function (n) {
          function t(n, t, r) {
            i.listen(n, t, r),
              e.fieldListeners.push({ field: n, event: t, action: r });
          }
          function f(n) {
            function f() {
              o.appendChild(e.element), e.focus(n);
            }
            var u = i.create('table', {
                className: 'pca pcaanchor',
                cellPadding: 0,
                cellSpacing: 0,
              }),
              s = [u.insertRow(0).insertCell(0), u.insertRow(1).insertCell(0)],
              o = i.create('div', { className: 'pcachain' });
            if (!n || !n.tagName) {
              i.append(e.element);
              return;
            }
            n.parentNode.insertBefore(u, n),
              s[0].appendChild(n),
              s[1].appendChild(o),
              e.anchors.push(u),
              i.inputField(n) &&
                (t(n, 'keyup', e.keyup),
                t(n, 'keydown', e.keydown),
                t(n, 'focus', f),
                t(n, 'blur', e.blur),
                t(n, 'keypress', e.keypress),
                n == r.activeElement && f()),
              t(n, 'click', function () {
                e.click(n);
              }),
              t(n, 'dblclick', function () {
                e.dblclick(n);
              }),
              t(n, 'change', function () {
                e.change(n);
              });
          }
          function u(n) {
            function u() {
              e.focus(n);
            }
            (i.append(e.element), n && n.tagName) &&
              (i.inputField(n) &&
                (t(n, 'keyup', e.keyup),
                t(n, 'keydown', e.keydown),
                t(n, 'focus', u),
                t(n, 'blur', e.blur),
                t(n, 'keypress', e.keypress),
                n == r.activeElement && u()),
              t(n, 'click', function () {
                e.click(n);
              }),
              t(n, 'dblclick', function () {
                e.dblclick(n);
              }),
              t(n, 'change', function () {
                e.change(n);
              }));
          }
          e.options.force ? f(n) : u(n);
        }),
        (e.position = function (t) {
          var o = i.getPosition(t),
            c = i.getSize(t),
            a = i.getTopOffsetParent(t),
            h = i.getParentScroll(t),
            s = i.getSize(e.element),
            v = i.getSize(n),
            r = i.getScroll(n),
            f = !u(a),
            l;
          return (
            o.top - (f ? 0 : r.top) > s.height &&
            o.top + s.height - (f ? 0 : r.top) > v.height
              ? e.options.force
                ? (e.element.style.top = -(s.height + c.height + 2) + 'px')
                : ((e.element.style.top =
                    o.top - h.top - s.height + (f ? r.top : 0) + 'px'),
                  (e.element.style.left =
                    o.left - h.left + (f ? r.left : 0) + 'px'))
              : e.options.force
              ? (e.element.style.top = 'auto')
              : ((e.element.style.top =
                  o.top - h.top + c.height + 1 + (f ? r.top : 0) + 'px'),
                (e.element.style.left =
                  o.left - h.left + (f ? r.left : 0) + 'px')),
            e.fixedWidth ||
              ((l =
                parseInt(i.getStyle(e.element, 'borderLeftWidth')) +
                  parseInt(i.getStyle(e.element, 'borderRightWidth')) || 0),
              (e.element.style.minWidth =
                Math.max(i.getSize(t).width - l, 0) + 'px')),
            (e.positionField = t),
            e.fire('move'),
            e
          );
        }),
        (e.reposition = function () {
          return e.positionField && e.position(e.positionField), e;
        }),
        (e.prompt = function (n, t) {
          if (typeof t == 'number')
            if (
              (t == 0
                ? (n = ' ' + n)
                : t >= n.length
                ? ((n = n + ' '), t++)
                : ((n = n.substring(0, t) + '  ' + n.substring(t, n.length)),
                  t++),
              i.setValue(e.field, n),
              e.field.focus(),
              e.field.createTextRange)
            ) {
              var r = e.field.createTextRange();
              r.move('character', t), r.select();
            } else e.field.selectionStart && e.field.setSelectionRange(t, t);
          else i.setValue(e.field, n);
          return e;
        }),
        (e.show = function () {
          return (
            e.disabled ||
              ((e.visible = !0),
              (e.element.style.display = ''),
              e.list.collection.count
                ? (e.options.emptyMessage && e.header.clear().hide(),
                  e.list.show())
                : (e.options.emptyMessage &&
                    e.header.setText(e.options.emptyMessage).show(),
                  e.list.hide()),
              e.setScroll(0),
              e.reposition(),
              e.fire('show')),
            e
          );
        }),
        (e.showAll = function () {
          e.list.filter(''), e.show();
        }),
        (e.hide = function () {
          return (
            (e.visible = !1),
            (e.element.style.display = 'none'),
            e.fire('hide'),
            e
          );
        }),
        (e.focus = function (n) {
          (e.field = n),
            (e.focused = !0),
            e.show(),
            e.position(n),
            e.fire('focus');
        }),
        (e.blur = function () {
          (e.focused = !1), e.checkHide(), e.fire('blur');
        }),
        (e.checkHide = function () {
          return !e.visible || e.focused || e.hover || e.hide(), e;
        }),
        (e.handleKey = function (n, t) {
          if (n != 13) {
            n == 27
              ? (e.hide(), e.fire('escape'))
              : n == 17
              ? (e.controlDown = !1)
              : n == 8 || n == 46
              ? (e.filter(), e.fire('delete'))
              : n != 0 && n <= 46
              ? e.visible && e.list.navigate(n)
                ? t && i.smash(t)
                : (n == 38 || n == 40) && e.filter()
              : e.visible && e.filter(),
              e.fire('keyup', n);
          }
        }),
        (e.keydown = function (t) {
          t = t || n.event;
          var i = t.which || t.keyCode;
          i == 17 && (e.controlDown = !0);
        }),
        (e.keyup = function (t) {
          t = t || n.event;
          var i = t.which || t.keyCode;
          e.handleKey(i, t);
        }),
        (e.keypress = function (t) {
          var r = n.event ? n.event.keyCode : t.which;
          e.visible && r == 13 && e.list.selectable() && i.smash(t);
        }),
        (e.click = function (n) {
          e.fire('click', n);
        }),
        (e.dblclick = function (n) {
          e.fire('dblclick', n);
        }),
        (e.change = function (n) {
          e.fire('change', n);
        }),
        (e.add = function (n, t, i) {
          return e.list.add(n, t, i), e;
        }),
        (e.clear = function () {
          return e.list.clear(), e;
        }),
        (e.setScroll = function (n) {
          return e.list.setScroll(n), e;
        }),
        (e.setWidth = function (n) {
          return (
            typeof n == 'number'
              ? ((n = Math.max(n, 220)),
                (e.element.style.width = n + 'px'),
                r.documentMode && r.documentMode <= 5 && (n -= 2),
                (e.list.element.style.width = n + 'px'))
              : ((e.element.style.width = n), (e.list.element.style.width = n)),
            (e.fixedWidth = n != 'auto'),
            (e.element.style.minWidth = 0),
            e
          );
        }),
        (e.setHeight = function (n) {
          return (
            (e.list.element.style.height = typeof n == 'number' ? n + 'px' : n),
            e
          );
        }),
        (e.filter = function (n) {
          return (
            (n = n || i.getValue(e.field)),
            e.skipFilter
              ? e.list.collection.match(n).length < e.list.collection.count &&
                e.list.fire('filter')
              : (e.list.filter(n, e.skipFilter),
                n &&
                !e.list.collection.count &&
                !e.skipFilter &&
                !e.options.emptyMessage
                  ? e.hide()
                  : e.show()),
            e.fire('filter', n),
            e
          );
        }),
        (e.disable = function () {
          return (e.disabled = !0), e;
        }),
        (e.enable = function () {
          return (e.disabled = !1), e;
        }),
        (e.destroy = function () {
          i.remove(e.element), i.ignore(r, 'click', e.checkHide);
          for (var n = 0; n < e.fieldListeners.length; n++)
            i.ignore(
              e.fieldListeners[n].field,
              e.fieldListeners[n].event,
              e.fieldListeners[n].action
            );
        }),
        e.element.appendChild(e.header.element),
        e.element.appendChild(e.list.element),
        e.element.appendChild(e.footer.element),
        e.header.init(),
        e.footer.init(),
        t && e.load(t),
        e.options.width && e.setWidth(e.options.width),
        e.options.height && e.setHeight(e.options.height),
        e.field || e.hide(),
        e
      );
    }),
    (i.Modal = function (n) {
      function u(n) {
        return (n = n || {}), (n.type = n.type || 'text'), n;
      }
      var t = new i.Eventable(this);
      return (
        (t.options = n || {}),
        (t.element = i.create('div', { className: 'pcamodal' })),
        (t.border = i.create('div', { className: 'pcaborder' })),
        (t.frame = i.create('div', { className: 'pcaframe' })),
        (t.content = i.create('div', { className: 'pcacontent pcatext' })),
        (t.mask = i.create('div', { className: 'pcafullscreen pcamask' })),
        (t.form = []),
        (t.header = {
          element: i.create('div', { className: 'pcaheader' }),
          headerText: i.create(
            'div',
            { className: 'pcatitle' },
            t.options.titleStyle || ''
          ),
          init: function () {
            this.setText(t.options.title || '');
          },
          setContent: function (n) {
            return (
              (n = n || ''),
              typeof n == 'string'
                ? (this.element.innerHTML = n)
                : this.element.appendChild(n),
              t.fire('header'),
              this
            );
          },
          setText: function (n) {
            return (
              (n = n || ''),
              this.element.appendChild(this.headerText),
              typeof n == 'string'
                ? (this.headerText.innerHTML = n)
                : this.headerText.appendChild(n),
              t.fire('header'),
              this
            );
          },
          show: function () {
            return (this.element.style.display = ''), t.fire('header'), this;
          },
          hide: function () {
            return (
              (this.element.style.display = 'none'), t.fire('header'), this
            );
          },
        }),
        (t.footer = {
          element: i.create('div', { className: 'pcafooter' }),
          setContent: function (n) {
            return (
              (n = n || ''),
              typeof n == 'string'
                ? (this.element.innerHTML = n)
                : this.element.appendChild(n),
              t.fire('footer'),
              this
            );
          },
          show: function () {
            return (this.element.style.display = ''), t.fire('header'), this;
          },
          hide: function () {
            return (
              (this.element.style.display = 'none'), t.fire('header'), this
            );
          },
        }),
        (t.setTitle = function (n) {
          t.header.setText(n).show();
        }),
        (t.setContent = function (n) {
          return (
            typeof n == 'string'
              ? (t.content.innerHTML = n)
              : t.content.appendChild(n),
            t.fire('change'),
            t
          );
        }),
        (t.addField = function (n, r) {
          r = u(r);
          var e = i.create('div', { className: 'pcainputrow' }),
            f = i.create(r.tag || 'input', r),
            o = i.create('label', { htmlFor: f.id || '', innerHTML: n || '' });
          return (
            e.appendChild(o),
            e.appendChild(f),
            t.setContent(e),
            t.form.push({ label: n, element: f }),
            f
          );
        }),
        (t.addHalfFields = function (n, r, f) {
          (r = u(r)), (f = u(f));
          var s = i.create('div', { className: 'pcainputrow' }),
            e = i.create(r.tag || 'input', r),
            o = i.create(f.tag || 'input', f),
            h = i.create('label', { htmlFor: e.id || '', innerHTML: n || '' });
          return (
            i.addClass(e, 'pcahalf'),
            i.addClass(o, 'pcahalf'),
            s.appendChild(h),
            s.appendChild(e),
            s.appendChild(o),
            t.setContent(s),
            t.form.push({ label: 'First ' + n, element: e }),
            t.form.push({ label: 'Second ' + n, element: o }),
            [e, o]
          );
        }),
        (t.addButton = function (n, u, f) {
          function o() {
            for (var r = {}, n = 0; n < t.form.length; n++)
              r[t.form[n].label] = i.getValue(t.form[n].element);
            u(r);
          }
          var e = i.create('input', {
            type: 'button',
            value: n,
            className: 'pcabutton',
          });
          return (
            !f ||
              (r.documentMode && r.documentMode <= 7) ||
              (e.style.float = 'right'),
            i.listen(e, 'click', o),
            t.footer.setContent(e),
            e
          );
        }),
        (t.centre = function () {
          var n = i.getSize(t.element);
          return (
            (t.element.style.marginTop = -(n.height / 2) + 'px'),
            (t.element.style.marginLeft = -(n.width / 2) + 'px'),
            t
          );
        }),
        (t.show = function () {
          return (
            (r.documentMode && r.documentMode <= 5) ||
              /\bMSIE 6/.test(navigator.userAgent) ||
              ((t.element.style.display = ''),
              (t.mask.style.display = ''),
              t.centre(),
              t.fire('show')),
            t
          );
        }),
        (t.hide = function () {
          return (
            (t.element.style.display = 'none'),
            (t.mask.style.display = 'none'),
            t.fire('hide'),
            t
          );
        }),
        i.listen(t.mask, 'click', t.hide),
        t.element.appendChild(t.border),
        t.element.appendChild(t.frame),
        t.frame.appendChild(t.header.element),
        t.frame.appendChild(t.content),
        t.frame.appendChild(t.footer.element),
        t.header.init(),
        i.append(t.mask),
        i.append(t.element),
        t.hide(),
        t
      );
    }),
    (i.Tooltip = function (t, r) {
      var f = new i.Eventable(this);
      return (
        (f.element = i.create('div', { className: 'pcatooltip' })),
        (f.background = i.create('div', { className: 'pcabackground' })),
        (f.message = i.create('div', {
          className: 'pcamessage',
          innerText: r,
        })),
        (f.show = function () {
          return (
            (f.element.style.display = ''), f.position(), f.fire('show'), f
          );
        }),
        (f.hide = function () {
          return (f.element.style.display = 'none'), f.fire('hide'), f;
        }),
        (f.setMessage = function (n) {
          i.setValue(f.message, n);
        }),
        (f.position = function () {
          var h = i.getPosition(t),
            a = i.getSize(t),
            v = i.getTopOffsetParent(t),
            s = i.getSize(f.message),
            l = i.getSize(n),
            o = i.getScroll(n),
            c = !u(v),
            r = h.top - s.height - 5 + (c ? o.top : 0),
            e = h.left + a.width / 2 - s.width / 2 + (c ? o.left : 0);
          (r = Math.min(r, l.height + o.top - s.height)),
            (r = Math.max(r, 0)),
            (e = Math.min(e, l.width + o.left - s.width)),
            (e = Math.max(e, 0)),
            (f.element.style.top = r + 'px'),
            (f.element.style.left = e + 'px');
        }),
        (t = i.getElement(t)) &&
          (i.listen(t, 'mouseover', f.show), i.listen(t, 'mouseout', f.hide)),
        f.element.appendChild(f.background),
        f.element.appendChild(f.message),
        f.setMessage(r),
        i.append(f.element),
        f.hide(),
        f
      );
    }),
    (i.formatLine = function (n, t) {
      function i(t) {
        return (typeof n[t] == 'function' ? n[t]() : n[t]) || '';
      }
      return (
        (t = t.replace(/\{([^\}]*\{(\w+)\}[^\}]*)\}/g, function (n, t, r) {
          var u = i(r);
          return u ? t.replace(/\{(\w+)\}/g, u) : '';
        })),
        t.replace(/\{(\w+)\}/g, function (n, t) {
          return i(t);
        })
      );
    }),
    (i.formatTag = function (n) {
      return n
        ? i.replaceList(
            i.replaceList(i.removeHtml(n.toUpperCase()), i.diacritics),
            i.synonyms
          )
        : '';
    }),
    (i.formatTagWords = function (n) {
      return i.formatTag(n).split(' ');
    }),
    (i.formatCamel = function (n, t) {
      function i(n, i, r) {
        return i + t + r;
      }
      return (
        (t = t || ' '),
        (n = n.replace(/([a-z])([A-Z0-9])/g, i)),
        (n = n.replace(/([0-9])([A-Z])/g, i)),
        (n = n.replace(/([A-Z])([A-Z][a-z])/g, i))
      );
    }),
    (i.replaceList = function (n, t) {
      for (var i = 0; i < t.length; i++)
        n = n.toString().replace(t[i].r, t[i].w);
      return n;
    }),
    (i.removeHtml = function (n) {
      return n.replace(/<(?:.|\s)*?>+/g, '');
    }),
    (i.escapeHtml = function (n) {
      return i.replaceList(n, i.hypertext);
    }),
    (i.validId = function (n) {
      return /[a-z0-9-_:\.\[\]]+/gi.exec(n);
    }),
    (i.trimSpaces = function (n) {
      return n.replace(/^\s+|\s(?=\s)|\s$/g, '');
    }),
    (i.tidy = function (n, t) {
      t = t.replace('\\', '\\\\');
      var i = new RegExp('^' + t + '+|' + t + '(?=' + t + ')|' + t + '$', 'gi');
      return n.replace(i, '');
    }),
    (i.getText = function (n) {
      return /[a-zA-Z][a-zA-Z\s]+[a-zA-Z]/.exec(n);
    }),
    (i.getNumber = function (n) {
      return /\d+/.exec(n);
    }),
    (i.parseJSON = function (n) {
      return n &&
        /^[\],:{}\s]*$/.test(
          n
            .replace(/\\(?:["\\\/bfnrt]|u[0-9a-fA-F]{4})/g, '@')
            .replace(
              /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
              ']'
            )
            .replace(/(?:^|:|,)(?:\s*\[)+/g, '')
        )
        ? typeof JSON != 'undefined'
          ? JSON.parse(n)
          : eval(n)
        : {};
    }),
    (i.parseJSONDate = function (n) {
      return new Date(parseInt(i.getNumber(n)));
    }),
    (i.containsWord = function (n, t) {
      var i = new RegExp('\\b' + t + '\\b', 'gi');
      return i.test(n);
    }),
    (i.removeWord = function (n, t) {
      var i = new RegExp('\\s?\\b' + t + '\\b', 'gi');
      return n.replace(i, '');
    }),
    (i.merge = function (n, t) {
      for (var i in n) t[i] || (t[i] = n[i]);
    }),
    (i.getElement = function (n, t) {
      var f, u;
      if (!n) return null;
      if (typeof n.nodeType == 'number') return n;
      if (typeof n == 'string') {
        if (
          ((t = i.getElement(t) || r),
          (f = t.getElementById ? t.getElementById(n) : null),
          f)
        )
          return f;
        if (
          ((u = t.getElementsByName ? t.getElementsByName(n) : null), u.length)
        )
          return u[0];
      }
      return i.fuzzyMatch ? i.getElementByRegex(n, t) : null;
    }),
    (i.getElementByRegex = function (n, t) {
      var e, o, u, f;
      if (typeof n == 'string')
        try {
          n = new RegExp(n);
        } catch (s) {
          return null;
        }
      if (n && typeof n == 'object' && n.constructor == RegExp)
        for (t = i.getElement(t) || r, e = 0; e < i.fuzzyTags.length; e++)
          for (
            o = t.getElementsByTagName(i.fuzzyTags[e]), u = 0;
            u < o.length;
            u++
          )
            if (((f = o[u]), f.id && n.test(f.id))) return f;
      return null;
    }),
    (i.getValue = function (n) {
      if ((n = i.getElement(n))) {
        if (n.tagName == 'INPUT' || n.tagName == 'TEXTAREA')
          return n.type == 'checkbox' ? n.checked : n.value;
        if (n.tagName == 'SELECT') return n.options[n.selectedIndex].value;
        if (n.tagName == 'DIV' || n.tagName == 'SPAN' || n.tagName == 'TD')
          return n.innerHTML;
      }
      return '';
    }),
    (i.setValue = function (n, t) {
      var u, f, r;
      if ((t || t == '') && (n = i.getElement(n)))
        if (((u = t.toString()), (f = u.toLowerCase()), n.tagName == 'INPUT'))
          n.type == 'checkbox'
            ? (n.checked = (typeof t == 'boolean' && t) || f == 'true')
            : (n.value = i.tidy(u.replace(/\\n|\n/gi, ', '), ', '));
        else if (n.tagName == 'TEXTAREA') n.value = u.replace(/\\n|\n/gi, '\n');
        else if (n.tagName == 'SELECT') {
          for (r = 0; r < n.options.length; r++)
            if (
              n.options[r].value.toLowerCase() == f ||
              n.options[r].text.toLowerCase() == f
            ) {
              n.selectedIndex = r;
              return;
            }
        } else
          (n.tagName == 'DIV' || n.tagName == 'SPAN' || n.tagName == 'TD') &&
            (n.innerHTML = u.replace(/\\n|\n/gi, '<br/>'));
    }),
    (i.inputField = function (n) {
      return (n = i.getElement(n))
        ? n.tagName &&
            (n.tagName == 'INPUT' || n.tagName == 'TEXTAREA') &&
            n.type &&
            (n.type == 'text' ||
              n.type == 'search' ||
              n.type == 'email' ||
              n.type == 'textarea')
        : !1;
    }),
    (i.selectList = function (n) {
      return (n = i.getElement(n)) ? n.tagName && n.tagName == 'SELECT' : !1;
    }),
    (i.checkBox = function (n) {
      return (n = i.getElement(n))
        ? n.tagName && n.tagName == 'INPUT' && n.type && n.type == 'checkbox'
        : !1;
    }),
    (i.clear = function (n) {
      i.setValue(n, '');
    }),
    (i.getPosition = function (t) {
      var e = { left: 0, top: 0 },
        f,
        r;
      if ((t = i.getElement(t))) {
        if (!t.tagName) return e;
        if (typeof t.getBoundingClientRect != 'undefined') {
          var h = t.getBoundingClientRect(),
            o = !u(i.getTopOffsetParent(t)),
            c = i.getScroll(n),
            s = i.getParentScroll(t);
          return {
            left: h.left + s.left + (o ? 0 : c.left),
            top: h.top + s.top + (o ? 0 : c.top),
          };
        }
        (f = 0), (r = 0);
        do (f += t.offsetLeft), (r += t.offsetTop);
        while ((t = t.offsetParent));
        return { left: f, top: r };
      }
      return e;
    }),
    (i.getScroll = function (n) {
      return {
        left:
          n.scrollX ||
          n.scrollLeft ||
          (u(n) ? r.documentElement.scrollLeft || r.body.scrollLeft : 0),
        top:
          n.scrollY ||
          n.scrollTop ||
          (u(n) ? r.documentElement.scrollTop || r.body.scrollTop : 0),
      };
    }),
    (i.getSize = function (n) {
      return {
        height:
          n.offsetHeight ||
          n.innerHeight ||
          (u(n) ? r.documentElement.clientHeight || r.body.clientHeight : 0),
        width:
          n.offsetWidth ||
          n.innerWidth ||
          (u(n) ? r.documentElement.clientWidth || r.body.clientWidth : 0),
      };
    }),
    (i.getParentScroll = function (n) {
      var f = { left: 0, top: 0 },
        r,
        t;
      if ((n = i.getElement(n))) {
        if (!n.tagName || !(n = n.parentNode)) return f;
        (r = 0), (t = 0);
        do {
          if (u(n)) break;
          (r += n.scrollLeft), (t += n.scrollTop);
        } while ((n = n.parentNode));
        return { left: r, top: t };
      }
      return f;
    }),
    (i.getTopOffsetParent = function (n) {
      while (n.offsetParent)
        if (((n = n.offsetParent), i.getStyle(n, 'position') == 'fixed')) break;
      return n;
    }),
    (i.getStyle = function (t, i) {
      return (
        ((n.getComputedStyle ? n.getComputedStyle(t) : t.currentStyle) || {})[
          i
        ] || ''
      );
    }),
    (i.addClass = function (n, t) {
      (n = i.getElement(n)) &&
        (i.containsWord(n.className || '', t) ||
          (n.className += (n.className ? ' ' : '') + t));
    }),
    (i.removeClass = function (n, t) {
      (n = i.getElement(n)) && (n.className = i.removeWord(n.className, t));
    }),
    (i.applyStyleFixes = function (n, t) {
      for (var s, h, u, o, e, f = 0; f < r.styleSheets.length; f++)
        for (
          s = r.styleSheets[f], h = s.rules || s.cssRules || [], u = 0;
          u < h.length;
          u++
        )
          if (((o = h[u]), o.selectorText.toLowerCase() == n))
            for (e in t) o.style[e] = t[e];
      i.styleFixes.push({ selectorText: n, fixes: t });
    }),
    (i.reapplyStyleFixes = function () {
      var t = i.styleFixes,
        n;
      for (i.styleFixes = [], n = 0; n < t.length; n++)
        i.applyStyleFixes(t[n].selectorText, t[n].fixes);
    }),
    (i.createStyleSheet = function (n) {
      r.createStyleSheet
        ? (r.createStyleSheet().cssText = n)
        : r.head.appendChild(
            i.create('style', { type: 'text/css', innerHTML: n })
          );
    }),
    (i.create = function (n, t, i) {
      var f = r.createElement(n),
        u;
      for (u in t || {}) f[u] = t[u];
      return i && (f.style.cssText = i), f;
    }),
    (i.append = function (n) {
      i.container ||
        ((i.container = i.create('div', { className: 'pca' })),
        r.body.appendChild(i.container)),
        i.container.appendChild(n);
    }),
    (i.remove = function (n) {
      n &&
        n.parentNode &&
        n.parentNode == i.container &&
        i.container.removeChild(n);
    }),
    (i.listen = function (t, i, r, u) {
      n.addEventListener
        ? t.addEventListener(i, r, u)
        : t.attachEvent('on' + i, r);
    }),
    (i.fire = function (n, t) {
      if (r.createEvent) {
        var i = r.createEvent('HTMLEvents');
        return i.initEvent(t, !0, !0), !n.dispatchEvent(i);
      }
      return n.fireEvent('on' + t, r.createEventObject());
    }),
    (i.ignore = function (t, i, r) {
      n.removeEventListener
        ? t.removeEventListener(i, r)
        : t.detachEvent('on' + i, r);
    }),
    (i.smash = function (t) {
      var i = t || n.event;
      i.stopPropagation ? i.stopPropagation() : (i.cancelBubble = !0),
        i.preventDefault ? i.preventDefault() : (i.returnValue = !1);
    }),
    (i.debug = function (n) {
      typeof console != 'undefined' && console.debug && console.debug(n),
        i.setValue(r.getElementById('pcadebug'), n);
    }),
    v();
})(window);
(function () {
  var n = (window.pca = window.pca || {});
  (n.countries = [
    { iso2: 'AF', iso3: 'AFG', name: 'Afghanistan', flag: 1 },
    { iso2: 'AX', iso3: 'ALA', name: 'Åland', flag: 220 },
    {
      iso2: 'AL',
      iso3: 'ALB',
      name: 'Albania',
      alternates: ['Shqipëria'],
      flag: 2,
    },
    { iso2: 'DZ', iso3: 'DZA', name: 'Algeria', flag: 3 },
    { iso2: 'AS', iso3: 'ASM', name: 'American Samoa', flag: 4 },
    { iso2: 'AD', iso3: 'AND', name: 'Andorra', flag: 5 },
    { iso2: 'AO', iso3: 'AGO', name: 'Angola', flag: 6 },
    { iso2: 'AI', iso3: 'AIA', name: 'Anguilla', flag: 7 },
    { iso2: 'AQ', iso3: 'ATA', name: 'Antarctica', flag: 0 },
    { iso2: 'AG', iso3: 'ATG', name: 'Antigua and Barbuda', flag: 8 },
    { iso2: 'AR', iso3: 'ARG', name: 'Argentina', flag: 9 },
    { iso2: 'AM', iso3: 'ARM', name: 'Armenia', flag: 10 },
    { iso2: 'AW', iso3: 'ABW', name: 'Aruba', flag: 11 },
    { iso2: 'AU', iso3: 'AUS', name: 'Australia', flag: 12 },
    {
      iso2: 'AT',
      iso3: 'AUT',
      name: 'Austria',
      alternates: ['Österreich'],
      flag: 13,
    },
    { iso2: 'AZ', iso3: 'AZE', name: 'Azerbaijan', flag: 14 },
    { iso2: 'BS', iso3: 'BHS', name: 'Bahamas', flag: 15 },
    { iso2: 'BH', iso3: 'BHR', name: 'Bahrain', flag: 16 },
    { iso2: 'BD', iso3: 'BGD', name: 'Bangladesh', flag: 17 },
    { iso2: 'BB', iso3: 'BRB', name: 'Barbados', flag: 18 },
    { iso2: 'BY', iso3: 'BLR', name: 'Belarus', flag: 19 },
    {
      iso2: 'BE',
      iso3: 'BEL',
      name: 'Belgium',
      alternates: ['België'],
      flag: 20,
    },
    { iso2: 'BZ', iso3: 'BLZ', name: 'Belize', flag: 21 },
    { iso2: 'BJ', iso3: 'BEN', name: 'Benin', flag: 22 },
    { iso2: 'BM', iso3: 'BMU', name: 'Bermuda', flag: 23 },
    { iso2: 'BT', iso3: 'BTN', name: 'Bhutan', flag: 24 },
    { iso2: 'BO', iso3: 'BOL', name: 'Bolivia', flag: 25 },
    {
      iso2: 'BQ',
      iso3: 'BES',
      name: 'Bonaire, Sint Eustatius and Saba',
      flag: 0,
    },
    {
      iso2: 'BA',
      iso3: 'BIH',
      name: 'Bosnia and Herzegovina',
      alternates: ['Bosna i Hercegovina'],
      flag: 26,
    },
    { iso2: 'BW', iso3: 'BWA', name: 'Botswana', flag: 27 },
    { iso2: 'BV', iso3: 'BVT', name: 'Bouvet Island', flag: 0 },
    {
      iso2: 'BR',
      iso3: 'BRA',
      name: 'Brazil',
      alternates: ['Brasil'],
      flag: 28,
    },
    {
      iso2: 'IO',
      iso3: 'IOT',
      name: 'British Indian Ocean Territory',
      flag: 29,
    },
    { iso2: 'VG', iso3: 'VGB', name: 'British Virgin Islands', flag: 30 },
    { iso2: 'BN', iso3: 'BRN', name: 'Brunei', flag: 0 },
    { iso2: 'BG', iso3: 'BGR', name: 'Bulgaria', flag: 31 },
    { iso2: 'BF', iso3: 'BFA', name: 'Burkina Faso', flag: 32 },
    { iso2: 'MM', iso3: 'MMR', name: 'Burma', flag: 33 },
    { iso2: 'BI', iso3: 'BDI', name: 'Burundi', flag: 34 },
    { iso2: 'KH', iso3: 'KHM', name: 'Cambodia', flag: 35 },
    { iso2: 'CM', iso3: 'CMR', name: 'Cameroon', flag: 36 },
    { iso2: 'CA', iso3: 'CAN', name: 'Canada', flag: 37 },
    { iso2: 'CV', iso3: 'CPV', name: 'Cape Verde', flag: 38 },
    { iso2: 'KY', iso3: 'CYM', name: 'Cayman Islands', flag: 39 },
    { iso2: 'CF', iso3: 'CAF', name: 'Central African Republic', flag: 40 },
    { iso2: 'TD', iso3: 'TCD', name: 'Chad', flag: 41 },
    { iso2: 'CL', iso3: 'CHL', name: 'Chile', flag: 42 },
    { iso2: 'CN', iso3: 'CHN', name: 'China', flag: 43 },
    { iso2: 'CX', iso3: 'CXR', name: 'Christmas Island', flag: 0 },
    { iso2: 'CC', iso3: 'CCK', name: 'Cocos (Keeling) Islands', flag: 0 },
    { iso2: 'CO', iso3: 'COL', name: 'Colombia', flag: 44 },
    { iso2: 'KM', iso3: 'COM', name: 'Comoros', flag: 45 },
    { iso2: 'CG', iso3: 'COG', name: 'Congo', flag: 0 },
    { iso2: 'CD', iso3: 'COD', name: 'Congo (Democratic Republic)', flag: 46 },
    { iso2: 'CK', iso3: 'COK', name: 'Cook Islands', flag: 47 },
    { iso2: 'CR', iso3: 'CRI', name: 'Costa Rica', flag: 48 },
    {
      iso2: 'HR',
      iso3: 'HRV',
      name: 'Croatia',
      alternates: ['Hrvatska'],
      flag: 50,
    },
    { iso2: 'CU', iso3: 'CUB', name: 'Cuba', flag: 51 },
    { iso2: 'CW', iso3: 'CUW', name: 'Curaçao', flag: 0 },
    { iso2: 'CY', iso3: 'CYP', name: 'Cyprus', flag: 52 },
    {
      iso2: 'CZ',
      iso3: 'CZE',
      name: 'Czechia',
      alternates: ['Ceská republika'],
      flag: 53,
    },
    { iso2: 'DK', iso3: 'DNK', name: 'Denmark', flag: 54 },
    { iso2: 'DJ', iso3: 'DJI', name: 'Djibouti', flag: 55 },
    { iso2: 'DM', iso3: 'DMA', name: 'Dominica', flag: 56 },
    { iso2: 'DO', iso3: 'DOM', name: 'Dominican Republic', flag: 57 },
    { iso2: 'TL', iso3: 'TLS', name: 'East Timor', flag: 0 },
    { iso2: 'EC', iso3: 'ECU', name: 'Ecuador', flag: 61 },
    { iso2: 'EG', iso3: 'EGY', name: 'Egypt', flag: 58 },
    { iso2: 'SV', iso3: 'SLV', name: 'El Salvador', flag: 59 },
    { iso2: 'GQ', iso3: 'GNQ', name: 'Equatorial Guinea', flag: 62 },
    { iso2: 'ER', iso3: 'ERI', name: 'Eritrea', flag: 63 },
    {
      iso2: 'EE',
      iso3: 'EST',
      name: 'Estonia',
      alternates: ['Eesti'],
      flag: 64,
    },
    { iso2: 'ET', iso3: 'ETH', name: 'Ethiopia', flag: 65 },
    { iso2: 'FK', iso3: 'FLK', name: 'Falkland Islands', flag: 66 },
    { iso2: 'FO', iso3: 'FRO', name: 'Faroe Islands', flag: 67 },
    { iso2: 'FJ', iso3: 'FJI', name: 'Fiji', flag: 68 },
    {
      iso2: 'FI',
      iso3: 'FIN',
      name: 'Finland',
      alternates: ['Suomi'],
      flag: 69,
    },
    { iso2: 'FR', iso3: 'FRA', name: 'France', flag: 70 },
    { iso2: 'GF', iso3: 'GUF', name: 'French Guiana', flag: 0 },
    { iso2: 'PF', iso3: 'PYF', name: 'French Polynesia', flag: 71 },
    { iso2: 'TF', iso3: 'ATF', name: 'French Southern Territories', flag: 0 },
    { iso2: 'GA', iso3: 'GAB', name: 'Gabon', flag: 72 },
    { iso2: 'GM', iso3: 'GMB', name: 'Gambia', flag: 73 },
    { iso2: 'GE', iso3: 'GEO', name: 'Georgia', flag: 74 },
    {
      iso2: 'DE',
      iso3: 'DEU',
      name: 'Germany',
      alternates: ['Deutschland'],
      flag: 75,
    },
    { iso2: 'GH', iso3: 'GHA', name: 'Ghana', flag: 76 },
    { iso2: 'GI', iso3: 'GIB', name: 'Gibraltar', flag: 77 },
    {
      iso2: 'GR',
      iso3: 'GRC',
      name: 'Greece',
      alternates: ['Hellas'],
      flag: 79,
    },
    { iso2: 'GL', iso3: 'GRL', name: 'Greenland', flag: 80 },
    { iso2: 'GD', iso3: 'GRD', name: 'Grenada', flag: 81 },
    { iso2: 'GP', iso3: 'GLP', name: 'Guadeloupe', flag: 0 },
    { iso2: 'GU', iso3: 'GUM', name: 'Guam', flag: 82 },
    { iso2: 'GT', iso3: 'GTM', name: 'Guatemala', flag: 83 },
    { iso2: 'GG', iso3: 'GGY', name: 'Guernsey', flag: 84 },
    { iso2: 'GN', iso3: 'GIN', name: 'Guinea', flag: 85 },
    { iso2: 'GW', iso3: 'GNB', name: 'Guinea-Bissau', flag: 86 },
    { iso2: 'GY', iso3: 'GUY', name: 'Guyana', flag: 87 },
    { iso2: 'HT', iso3: 'HTI', name: 'Haiti', flag: 88 },
    {
      iso2: 'HM',
      iso3: 'HMD',
      name: 'Heard Island and McDonald Islands',
      flag: 0,
    },
    { iso2: 'HN', iso3: 'HND', name: 'Honduras', flag: 89 },
    { iso2: 'HK', iso3: 'HKG', name: 'Hong Kong', flag: 90 },
    {
      iso2: 'HU',
      iso3: 'HUN',
      name: 'Hungary',
      alternates: ['Magyarország'],
      flag: 91,
    },
    {
      iso2: 'IS',
      iso3: 'ISL',
      name: 'Iceland',
      alternates: ['Ísland'],
      flag: 92,
    },
    { iso2: 'IN', iso3: 'IND', name: 'India', flag: 93 },
    { iso2: 'ID', iso3: 'IDN', name: 'Indonesia', flag: 94 },
    { iso2: 'IR', iso3: 'IRN', name: 'Iran', flag: 95 },
    { iso2: 'IQ', iso3: 'IRQ', name: 'Iraq', flag: 96 },
    { iso2: 'IE', iso3: 'IRL', name: 'Ireland', flag: 97 },
    { iso2: 'IM', iso3: 'IMN', name: 'Isle of Man', flag: 98 },
    { iso2: 'IL', iso3: 'ISR', name: 'Israel', flag: 99 },
    {
      iso2: 'IT',
      iso3: 'ITA',
      name: 'Italy',
      alternates: ['Italia'],
      flag: 100,
    },
    { iso2: 'CI', iso3: 'CIV', name: 'Ivory Coast', flag: 49 },
    { iso2: 'JM', iso3: 'JAM', name: 'Jamaica', flag: 101 },
    { iso2: 'JP', iso3: 'JPN', name: 'Japan', flag: 102 },
    { iso2: 'JE', iso3: 'JEY', name: 'Jersey', flag: 103 },
    { iso2: 'JO', iso3: 'JOR', name: 'Jordan', flag: 104 },
    { iso2: 'KZ', iso3: 'KAZ', name: 'Kazakhstan', flag: 105 },
    { iso2: 'KE', iso3: 'KEN', name: 'Kenya', flag: 106 },
    { iso2: 'KI', iso3: 'KIR', name: 'Kiribati', flag: 107 },
    { iso2: 'KP', iso3: 'PRK', name: 'Korea (North)', flag: 149 },
    { iso2: 'KR', iso3: 'KOR', name: 'Korea (South)', flag: 185 },
    { iso2: 'KW', iso3: 'KWT', name: 'Kuwait', flag: 108 },
    { iso2: 'KG', iso3: 'KGZ', name: 'Kyrgyzstan', flag: 109 },
    { iso2: 'LA', iso3: 'LAO', name: 'Laos', flag: 0 },
    { iso2: 'LV', iso3: 'LVA', name: 'Latvia', flag: 110 },
    { iso2: 'LB', iso3: 'LBN', name: 'Lebanon', flag: 111 },
    { iso2: 'LS', iso3: 'LSO', name: 'Lesotho', flag: 112 },
    { iso2: 'LR', iso3: 'LBR', name: 'Liberia', flag: 113 },
    { iso2: 'LY', iso3: 'LBY', name: 'Libya', flag: 114 },
    { iso2: 'LI', iso3: 'LIE', name: 'Liechtenstein', flag: 115 },
    {
      iso2: 'LT',
      iso3: 'LTU',
      name: 'Lithuania',
      alternates: ['Lietuva'],
      flag: 116,
    },
    { iso2: 'LU', iso3: 'LUX', name: 'Luxembourg', flag: 117 },
    { iso2: 'MO', iso3: 'MAC', name: 'Macao', flag: 118 },
    {
      iso2: 'MK',
      iso3: 'MKD',
      name: 'Macedonia',
      alternates: ['Poraneshna Jugoslovenska Republika Makedonija'],
      flag: 119,
    },
    { iso2: 'MG', iso3: 'MDG', name: 'Madagascar', flag: 120 },
    { iso2: 'MW', iso3: 'MWI', name: 'Malawi', flag: 121 },
    { iso2: 'MY', iso3: 'MYS', name: 'Malaysia', flag: 122 },
    { iso2: 'MV', iso3: 'MDV', name: 'Maldives', flag: 123 },
    { iso2: 'ML', iso3: 'MLI', name: 'Mali', flag: 124 },
    { iso2: 'MT', iso3: 'MLT', name: 'Malta', flag: 125 },
    { iso2: 'MH', iso3: 'MHL', name: 'Marshall Islands', flag: 126 },
    { iso2: 'MQ', iso3: 'MTQ', name: 'Martinique', flag: 127 },
    { iso2: 'MR', iso3: 'MRT', name: 'Mauritania', flag: 128 },
    { iso2: 'MU', iso3: 'MUS', name: 'Mauritius', flag: 129 },
    { iso2: 'YT', iso3: 'MYT', name: 'Mayotte', flag: 0 },
    { iso2: 'MX', iso3: 'MEX', name: 'Mexico', flag: 130 },
    { iso2: 'FM', iso3: 'FSM', name: 'Micronesia', flag: 131 },
    { iso2: 'MD', iso3: 'MDA', name: 'Moldova', flag: 132 },
    { iso2: 'MC', iso3: 'MCO', name: 'Monaco', flag: 133 },
    { iso2: 'MN', iso3: 'MNG', name: 'Mongolia', flag: 134 },
    {
      iso2: 'ME',
      iso3: 'MNE',
      name: 'Montenegro',
      alternates: ['Crna Gora'],
      flag: 0,
    },
    { iso2: 'MS', iso3: 'MSR', name: 'Montserrat', flag: 135 },
    { iso2: 'MA', iso3: 'MAR', name: 'Morocco', flag: 136 },
    { iso2: 'MZ', iso3: 'MOZ', name: 'Mozambique', flag: 137 },
    { iso2: 'NA', iso3: 'NAM', name: 'Namibia', flag: 138 },
    { iso2: 'NR', iso3: 'NRU', name: 'Nauru', flag: 139 },
    { iso2: 'NP', iso3: 'NPL', name: 'Nepal', flag: 140 },
    {
      iso2: 'NL',
      iso3: 'NLD',
      name: 'Netherlands',
      alternates: ['Holland'],
      flag: 141,
    },
    { iso2: 'NC', iso3: 'NCL', name: 'New Caledonia', flag: 0 },
    { iso2: 'NZ', iso3: 'NZL', name: 'New Zealand', flag: 142 },
    { iso2: 'NI', iso3: 'NIC', name: 'Nicaragua', flag: 143 },
    { iso2: 'NE', iso3: 'NER', name: 'Niger', flag: 144 },
    { iso2: 'NG', iso3: 'NGA', name: 'Nigeria', flag: 145 },
    { iso2: 'NU', iso3: 'NIU', name: 'Niue', flag: 146 },
    { iso2: 'NF', iso3: 'NFK', name: 'Norfolk Island', flag: 147 },
    { iso2: 'MP', iso3: 'MNP', name: 'Northern Mariana Islands', flag: 148 },
    { iso2: 'NO', iso3: 'NOR', name: 'Norway', flag: 150 },
    { iso2: 'OM', iso3: 'OMN', name: 'Oman', flag: 151 },
    { iso2: 'PK', iso3: 'PAK', name: 'Pakistan', flag: 152 },
    { iso2: 'PW', iso3: 'PLW', name: 'Palau', flag: 153 },
    { iso2: 'PS', iso3: 'PSE', name: 'Palestine', flag: 0 },
    { iso2: 'PA', iso3: 'PAN', name: 'Panama', flag: 154 },
    { iso2: 'PG', iso3: 'PNG', name: 'Papua New Guinea', flag: 155 },
    { iso2: 'PY', iso3: 'PRY', name: 'Paraguay', flag: 156 },
    { iso2: 'PE', iso3: 'PER', name: 'Peru', flag: 157 },
    { iso2: 'PH', iso3: 'PHL', name: 'Philippines', flag: 158 },
    { iso2: 'PN', iso3: 'PCN', name: 'Pitcairn', flag: 0 },
    {
      iso2: 'PL',
      iso3: 'POL',
      name: 'Poland',
      alternates: ['Polska'],
      flag: 159,
    },
    { iso2: 'PT', iso3: 'PRT', name: 'Portugal', flag: 160 },
    { iso2: 'PR', iso3: 'PRI', name: 'Puerto Rico', flag: 161 },
    { iso2: 'QA', iso3: 'QAT', name: 'Qatar', flag: 162 },
    { iso2: 'RE', iso3: 'REU', name: 'Réunion', flag: 0 },
    {
      iso2: 'RO',
      iso3: 'ROU',
      name: 'Romania',
      alternates: ['România'],
      flag: 163,
    },
    {
      iso2: 'RU',
      iso3: 'RUS',
      name: 'Russia',
      alternates: ['Rossiya'],
      flag: 164,
    },
    { iso2: 'RW', iso3: 'RWA', name: 'Rwanda', flag: 165 },
    { iso2: 'MF', iso3: 'MAF', name: 'Saint Martin (French)', flag: 0 },
    { iso2: 'WS', iso3: 'WSM', name: 'Samoa', flag: 171 },
    { iso2: 'SM', iso3: 'SMR', name: 'San Marino', flag: 172 },
    { iso2: 'ST', iso3: 'STP', name: 'Sao Tome and Principe', flag: 173 },
    { iso2: 'SA', iso3: 'SAU', name: 'Saudi Arabia', flag: 174 },
    { iso2: 'SN', iso3: 'SEN', name: 'Senegal', flag: 175 },
    {
      iso2: 'RS',
      iso3: 'SRB',
      name: 'Serbia',
      alternates: ['Srbija'],
      flag: 0,
    },
    { iso2: 'SC', iso3: 'SYC', name: 'Seychelles', flag: 176 },
    { iso2: 'SL', iso3: 'SLE', name: 'Sierra Leone', flag: 177 },
    { iso2: 'SG', iso3: 'SGP', name: 'Singapore', flag: 178 },
    { iso2: 'SX', iso3: 'SXM', name: 'Sint Maarten (Dutch)', flag: 0 },
    {
      iso2: 'SK',
      iso3: 'SVK',
      name: 'Slovakia',
      alternates: ['Slovenská republika'],
      flag: 179,
    },
    {
      iso2: 'SI',
      iso3: 'SVN',
      name: 'Slovenia',
      alternates: ['Slovenija'],
      flag: 180,
    },
    { iso2: 'SB', iso3: 'SLB', name: 'Solomon Islands', flag: 181 },
    { iso2: 'SO', iso3: 'SOM', name: 'Somalia', flag: 182 },
    { iso2: 'ZA', iso3: 'ZAF', name: 'South Africa', flag: 183 },
    {
      iso2: 'GS',
      iso3: 'SGS',
      name: 'South Georgia and the South Sandwich Islands',
      flag: 184,
    },
    { iso2: 'SS', iso3: 'SSD', name: 'South Sudan ', flag: 0 },
    {
      iso2: 'ES',
      iso3: 'ESP',
      name: 'Spain',
      alternates: ['España'],
      flag: 186,
    },
    { iso2: 'LK', iso3: 'LKA', name: 'Sri Lanka', flag: 187 },
    { iso2: 'BL', iso3: 'BLM', name: 'St Barthélemy', flag: 0 },
    {
      iso2: 'SH',
      iso3: 'SHN',
      name: 'St Helena, Ascension and Tristan da Cunha',
      flag: 166,
    },
    { iso2: 'KN', iso3: 'KNA', name: 'St Kitts and Nevis', flag: 167 },
    { iso2: 'LC', iso3: 'LCA', name: 'St Lucia', flag: 168 },
    { iso2: 'PM', iso3: 'SPM', name: 'St Pierre and Miquelon', flag: 169 },
    { iso2: 'VC', iso3: 'VCT', name: 'St Vincent', flag: 170 },
    { iso2: 'SD', iso3: 'SDN', name: 'Sudan', flag: 188 },
    { iso2: 'SR', iso3: 'SUR', name: 'Suriname', flag: 189 },
    { iso2: 'SJ', iso3: 'SJM', name: 'Svalbard and Jan Mayen', flag: 190 },
    { iso2: 'SZ', iso3: 'SWZ', name: 'Swaziland', flag: 191 },
    {
      iso2: 'SE',
      iso3: 'SWE',
      name: 'Sweden',
      alternates: ['Sverige'],
      flag: 192,
    },
    {
      iso2: 'CH',
      iso3: 'CHE',
      name: 'Switzerland',
      alternates: ['Schweiz'],
      flag: 193,
    },
    { iso2: 'SY', iso3: 'SYR', name: 'Syria', flag: 0 },
    { iso2: 'TW', iso3: 'TWN', name: 'Taiwan', flag: 194 },
    { iso2: 'TJ', iso3: 'TJK', name: 'Tajikistan', flag: 195 },
    { iso2: 'TZ', iso3: 'TZA', name: 'Tanzania', flag: 196 },
    { iso2: 'TH', iso3: 'THA', name: 'Thailand', flag: 197 },
    { iso2: 'TG', iso3: 'TGO', name: 'Togo', flag: 198 },
    { iso2: 'TK', iso3: 'TKL', name: 'Tokelau', flag: 0 },
    { iso2: 'TO', iso3: 'TON', name: 'Tonga', flag: 199 },
    { iso2: 'TT', iso3: 'TTO', name: 'Trinidad and Tobago', flag: 200 },
    { iso2: 'TN', iso3: 'TUN', name: 'Tunisia', flag: 201 },
    {
      iso2: 'TR',
      iso3: 'TUR',
      name: 'Turkey',
      alternates: ['Türkiye'],
      flag: 202,
    },
    { iso2: 'TM', iso3: 'TKM', name: 'Turkmenistan', flag: 203 },
    { iso2: 'TC', iso3: 'TCA', name: 'Turks and Caicos Islands', flag: 204 },
    { iso2: 'TV', iso3: 'TUV', name: 'Tuvalu', flag: 205 },
    { iso2: 'UG', iso3: 'UGA', name: 'Uganda', flag: 206 },
    {
      iso2: 'UA',
      iso3: 'UKR',
      name: 'Ukraine',
      alternates: ['Ukraina'],
      flag: 207,
    },
    {
      iso2: 'AE',
      iso3: 'ARE',
      name: 'United Arab Emirates',
      alternates: ['UAE'],
      flag: 208,
    },
    {
      iso2: 'GB',
      iso3: 'GBR',
      name: 'United Kingdom',
      alternates: [
        'Britain',
        'England',
        'Great Britain',
        'Northern Ireland',
        'Scotland',
        'UK',
        'Wales',
      ],
      flag: 78,
    },
    {
      iso2: 'US',
      iso3: 'USA',
      name: 'United States',
      alternates: ['America', 'United States of America'],
      flag: 210,
    },
    {
      iso2: 'UM',
      iso3: 'UMI',
      name: 'United States Minor Outlying Islands',
      flag: 0,
    },
    {
      iso2: 'VI',
      iso3: 'VIR',
      name: 'United States Virgin Islands',
      flag: 215,
    },
    { iso2: 'UY', iso3: 'URY', name: 'Uruguay', flag: 209 },
    { iso2: 'UZ', iso3: 'UZB', name: 'Uzbekistan', flag: 211 },
    { iso2: 'VU', iso3: 'VUT', name: 'Vanuatu', flag: 212 },
    { iso2: 'VA', iso3: 'VAT', name: 'Vatican City', flag: 0 },
    { iso2: 'VE', iso3: 'VEN', name: 'Venezuela', flag: 213 },
    { iso2: 'VN', iso3: 'VNM', name: 'Vietnam', flag: 214 },
    { iso2: 'WF', iso3: 'WLF', name: 'Wallis and Futuna', flag: 216 },
    { iso2: 'EH', iso3: 'ESH', name: 'Western Sahara', flag: 0 },
    { iso2: 'YE', iso3: 'YEM', name: 'Yemen', flag: 217 },
    { iso2: 'ZM', iso3: 'ZMB', name: 'Zambia', flag: 218 },
    { iso2: 'ZW', iso3: 'ZWE', name: 'Zimbabwe', flag: 219 },
  ]),
    (n.countryNameType = { NAME: 0, ISO2: 1, ISO3: 2 }),
    (n.CountryList = function (t, i) {
      var r = new n.Eventable(this);
      (r.fields = t || []),
        (r.options = i || {}),
        (r.options.defaultCode = r.options.defaultCode || ''),
        (r.options.value = r.options.value || ''),
        (r.options.codesList = r.options.codesList || ''),
        (r.options.fillOthers = r.options.fillOthers || !1),
        (r.options.list = r.options.list || {}),
        (r.options.populate =
          typeof r.options.populate == 'boolean' ? r.options.populate : !0),
        (r.options.prepopulate =
          typeof r.options.prepopulate == 'boolean'
            ? r.options.prepopulate
            : !0),
        (r.options.nameType = r.options.nameType || n.countryNameType.NAME),
        (r.options.valueType = r.options.valueType || n.countryNameType.ISO3),
        (r.options.fallbackCode = r.options.fallbackCode || 'CAN'),
        (r.template =
          "<div class='pcaflag'></div><div class='pcaflaglabel'>{name}</div>"),
        (r.autocomplete = new n.AutoComplete(r.fields, r.options.list)),
        (r.country = null),
        (r.textChanged = !1),
        (r.load = function () {
          function c(t) {
            r.setCountry(n.getValue(t)), (r.textChanged = !1);
          }
          var h, t, f, s, i, u, o, e;
          if (
            (n.addClass(r.autocomplete.element, 'pcacountrylist'),
            r.options.codesList)
          ) {
            for (
              h = r.options.codesList.replace(/\s/g, '').split(','),
                t = [],
                r.autocomplete.clear(),
                f = 0;
              f < h.length;
              f++
            )
              for (
                s = h[f].toString().toUpperCase(), i = 0;
                i < n.countries.length;
                i++
              )
                if (n.countries[i].iso2 == s || n.countries[i].iso3 == s) {
                  t.push(n.countries[i]);
                  break;
                }
            if (r.options.fillOthers)
              for (u = 0; u < n.countries.length; u++) {
                for (o = !1, e = 0; e < t.length; e++)
                  n.countries[u].iso3 == t[e].iso3 && (o = !0);
                o || t.push(n.countries[u]);
              }
            r.autocomplete.clear().add(t, r.template, r.change);
          } else r.autocomplete.clear().add(n.countries, r.template, r.change);
          r.autocomplete.list.collection.all(function (t) {
            r.setFlagPosition(t.element.firstChild, t.data.flag),
              (t.tag +=
                ' ' +
                n.formatTag(
                  t.data.iso3 +
                    (t.data.alternates ? ' ' + t.data.alternates.join(' ') : '')
                ));
          }),
            r.autocomplete.listen('focus', function () {
              r.autocomplete.showAll();
            }),
            r.autocomplete.listen('change', function (n) {
              r.autocomplete.visible ? (r.textChanged = !0) : c(n);
            }),
            r.autocomplete.listen('hide', function () {
              r.textChanged && c(r.autocomplete.field);
            }),
            r.options.value && (r.country = r.find(r.options.value)),
            !r.country &&
              r.options.defaultCode &&
              (r.country = r.find(r.options.defaultCode)),
            (r.country =
              r.country ||
              (r.options.codesList
                ? r.first()
                : r.find(r.options.fallbackCode)) ||
              r.first() ||
              r.find(r.options.fallbackCode)),
            r.fire('load');
        }),
        (r.getName = function (t) {
          switch (r.options.nameType) {
            case n.countryNameType.NAME:
              return (t || r.country).name;
            case n.countryNameType.ISO2:
              return (t || r.country).iso2;
            case n.countryNameType.ISO3:
              return (t || r.country).iso3;
          }
          return (t || r.country).name;
        }),
        (r.getValue = function (t) {
          switch (r.options.valueType) {
            case n.countryNameType.NAME:
              return (t || r.country).name;
            case n.countryNameType.ISO2:
              return (t || r.country).iso2;
            case n.countryNameType.ISO3:
              return (t || r.country).iso3;
          }
          return (t || r.country).iso3;
        }),
        (r.populate = function () {
          var e, f, i, t, u;
          if (r.options.populate) {
            for (
              e = r.getName(), f = r.getValue(), i = 0;
              i < r.fields.length;
              i++
            )
              (t = n.getElement(r.fields[i])),
                (u = n.getValue(t)),
                n.setValue(t, n.selectList(t) ? f : e),
                r.options.prepopulate &&
                  u != n.getValue(t) &&
                  n.fire(t, 'change');
            r.fire('populate');
          }
        }),
        (r.find = function (n) {
          function t(t) {
            if (t.data.alternates)
              for (var i = 0; i < t.data.alternates.length; i++)
                if (t.data.alternates[i].toUpperCase() == n) return !0;
            return !1;
          }
          return (
            (n = n.toString().toUpperCase()),
            (
              r.autocomplete.list.collection.first(function (i) {
                return (
                  i.data.iso2.toUpperCase() == n ||
                  i.data.iso3.toUpperCase() == n ||
                  i.data.name.toUpperCase() == n ||
                  t(i)
                );
              }) || {}
            ).data
          );
        }),
        (r.first = function () {
          return r.autocomplete.list.collection.first().data;
        }),
        (r.change = function (n) {
          n &&
            ((r.country = n),
            r.populate(),
            (r.textChanged = !1),
            r.fire('change', r.country));
        }),
        (r.setFlagPosition = function (n, t) {
          n.style.backgroundPosition = '-1px -' + (t * 16 + 2) + 'px';
        }),
        (r.flag = function () {
          function t(n) {
            r.setFlagPosition(i, n.flag);
          }
          var i = n.create('div', { className: 'pcaflag' });
          return t(r.country), r.listen('change', t), i;
        }),
        (r.setCountry = function (n) {
          return r.change(r.find(n)), r;
        }),
        (r.setCountryByIP = function (t) {
          function i(n) {
            n.length && n[0].Iso3 && r.setCountry(n[0].Iso3);
          }
          t && n.fetch('Extras/Web/Ip2Country/v1.10', { Key: t }, i);
        }),
        r.load();
    });
})();
(function () {
  var n = (window.pca = window.pca || {});
  (n.fieldMode = {
    DEFAULT: 3,
    NONE: 0,
    SEARCH: 1,
    POPULATE: 2,
    PRESERVE: 4,
    COUNTRY: 8,
  }),
    (n.Address = function (t, i) {
      function u() {
        r.reset(),
          r.autocomplete.show(),
          r.autocomplete.header
            .clear()
            .setContent(
              n.create(
                'div',
                {
                  className: 'pcamessage',
                  innerHTML: r.messages.NORESULTS,
                  onclick: r.manualEntry,
                },
                'cursor:pointer;'
              )
            )
            .show(),
          r.showFooterMessage(),
          r.autocomplete.clear().list.hide(),
          r.fire('noresults');
      }
      var r = new n.Eventable(this);
      (r.messages = {
        DIDYOUMEAN: 'Did you mean:',
        NORESULTS:
          'No results found. Try again or <u>enter your address manually.</u>',
        KEEPTYPING: 'Keep typing your address to display more results',
        RETRIEVEERROR: 'Record could not be retrieved',
        SERVICEERROR: 'Service Error:',
        COUNTRYSELECT: 'Select Country',
        NOLOCATION: 'Sorry, we could not get your location',
        NOCOUNTRY: 'Sorry, we could not find this country',
      }),
        (r.translations = {
          fr: {
            DIDYOUMEAN: 'Vouliez-vous dire:',
            NORESULTS:
              "Aucun résultat n'a été trouvé. Vérifiez l'orthographe et essayez de nouveau ou <u>saisissez votre adresse manuellement.</u>",
            KEEPTYPING:
              'Continuer à taper votre adresse pour afficher plus de résultats',
            RETRIEVEERROR: "Enregistrement n'a pas pu être récupéré",
            SERVICEERROR: 'Erreur de service:',
            COUNTRYSELECT: 'Changer de pays',
            NOLOCATION: "Désolé, nous n'avons pas pu obtenir votre emplacement",
            NOCOUNTRY: "Désolé, nous n'avons pas trouvé ce pays",
          },
          de: {
            DIDYOUMEAN: 'Meinten Sie:',
            NORESULTS: 'Keine Adressen gefunden',
            KEEPTYPING:
              'Geben Sie mehr von Ihrer Adresse ein, um weitere Ergebnisse anzuzeigen',
            RETRIEVEERROR: 'Wir konnten diese Adresse leider nicht abrufen',
            SERVICEERROR: 'Service-Fehler:',
            COUNTRYSELECT: 'Land wechseln',
            NOLOCATION: 'Wir konnten Ihren Standort leider nicht finden',
            NOCOUNTRY: 'Wir konnten dieses Land leider nicht finden',
          },
          en: {
            DIDYOUMEAN: 'Did you mean:',
            NORESULTS:
              'No results found. Try again or <u>enter your address manually.</u>',
            KEEPTYPING: 'Keep typing your address to display more results',
            RETRIEVEERROR: 'Record could not be retrieved',
            SERVICEERROR: 'Service Error:',
            COUNTRYSELECT: 'Select Country',
            NOLOCATION: 'Sorry, we could not get your location',
            NOCOUNTRY: 'Sorry, we could not find this country',
          },
        }),
        (r.searchMode = {
          EVERYTHING: 'Everything',
          POSTCODES: 'PostalCodes',
          COMPANIES: 'Companies',
          PLACES: 'Places',
        }),
        (r.templates = {
          AUTOCOMPLETE:
            "{HighlightedText}{ <span class='pcadescription'>{Description}</span>}",
        }),
        (r.fields = t || []),
        (r.options = i || {}),
        (r.key = r.options.key || ''),
        (r.options.source = r.options.source || ''),
        (r.options.populate =
          typeof r.options.populate == 'boolean' ? r.options.populate : !0),
        (r.options.onlyInputs =
          typeof r.options.onlyInputs == 'boolean' ? r.options.onlyInputs : !1),
        (r.options.autoSearch =
          typeof r.options.autoSearch == 'boolean' ? r.options.autoSearch : !1),
        (r.options.minSearch = r.options.minSearch || 1),
        (r.options.maxItems = r.options.maxItems || 0),
        (r.options.advancedFields = r.options.advancedFields || []),
        (r.options.disableTime = r.options.disableTime || 6e4),
        (r.options.promptTime = r.options.promptTime || 3e3),
        (r.options.suppressAutocomplete =
          typeof r.options.suppressAutocomplete == 'boolean'
            ? r.options.suppressAutocomplete
            : !1),
        (r.options.setCountryByIP =
          typeof r.options.setCountryByIP == 'boolean'
            ? r.options.setCountryByIP
            : !1),
        (r.options.brand =
          r.options.brand || 'CanadaPost' || 'PostcodeAnywhere'),
        (r.options.product =
          r.options.product || 'AddressComplete' || 'CapturePlus'),
        (r.options.culture = r.options.culture || 'en-GB'),
        (r.options.prompt =
          typeof r.options.prompt == 'boolean' ? r.options.prompt : !1),
        (r.options.setCursor =
          typeof r.options.setCursor == 'boolean' ? r.options.setCursor : !0),
        (r.options.languagePreference = r.options.languagePreference || ''),
        (r.options.countries = r.options.countries || {}),
        (r.options.countries.defaultCode =
          r.options.countries.defaultCode || '' || ''),
        (r.options.countries.value = r.options.countries.value || ''),
        (r.options.countries.prepopulate =
          typeof r.options.countries.prepopulate == 'boolean'
            ? r.options.countries.prepopulate
            : !0),
        (r.options.list = r.options.list || {}),
        (r.options.bar = r.options.bar || {}),
        (r.options.bar.visible =
          typeof r.options.bar.visible == 'boolean'
            ? r.options.bar.visible
            : !0),
        (r.options.bar.showCountry =
          typeof r.options.bar.showCountry == 'boolean'
            ? r.options.bar.showCountry
            : !0),
        (r.options.bar.showLogo =
          typeof r.options.bar.showLogo == 'boolean'
            ? r.options.bar.showLogo
            : !0),
        (r.options.bar.logoLink =
          typeof r.options.bar.logoLink == 'boolean'
            ? r.options.bar.logoLink
            : !0),
        (r.country = r.options.countries.defaultCode),
        (r.advancedFields = r.options.advancedFields),
        (r.initialSearch = !1),
        (r.lastSuggestion = null),
        (r.lastActionTime = null),
        (r.storedSearch = null),
        (r.geolocation = null),
        (r.loaded = !1),
        (r.languageCode = 'en'),
        (r.autocomplete = null),
        (r.countrylist = null),
        (r.load = function () {
          function p() {
            r.lastActionTime &&
              r.options.promptTime &&
              new Date() - r.lastActionTime > r.options.promptTime &&
              r.autocomplete.header
                .clear()
                .setText(r.messages.KEEPTYPING)
                .show();
          }
          for (
            var a = [], e = [], t, h, u, v, f, y, l, i, s, c, o = 0;
            o < r.fields.length;
            o++
          )
            (t = r.fields[o]),
              (t.mode =
                typeof t.mode == 'number' ? t.mode : n.fieldMode.DEFAULT),
              t.mode & n.fieldMode.COUNTRY
                ? (e.push(t.element),
                  /CountryIso2/.test(t.field) &&
                    ((r.options.countries.nameType =
                      r.options.countries.nameType || n.countryNameType.ISO2),
                    (r.options.countries.valueType =
                      r.options.countries.valueType || n.countryNameType.ISO2)),
                  /CountryIso3/.test(t.field) &&
                    ((r.options.countries.nameType =
                      r.options.countries.nameType || n.countryNameType.ISO3),
                    (r.options.countries.valueType =
                      r.options.countries.valueType || n.countryNameType.ISO3)))
                : t.mode & n.fieldMode.SEARCH && a.push(t.element),
              r.options.suppressAutocomplete &&
                ((h = n.getElement(t.element)), h && (h.autocomplete = 'off'));
          (r.autocomplete = new n.AutoComplete(a, r.options.list)),
            (r.autocomplete.skipFilter = !0),
            r.autocomplete.listen('keyup', function (n) {
              (r.lastActionTime = new Date()),
                r.countrylist.autocomplete.visible
                  ? r.countrylist.autocomplete.handleKey(n)
                  : r.autocomplete.controlDown && n == 40
                  ? r.switchToCountrySelect()
                  : (n == 0 || n == 8 || n > 36) && r.searchFromField();
            }),
            r.listen('display', function () {
              r.lastActionTime = new Date();
            }),
            r.autocomplete.listen('focus', r.focus),
            r.autocomplete.listen('blur', r.blur),
            r.autocomplete.listen('dblclick', r.searchFromField),
            r.autocomplete.list.listen('filter', function () {
              r.search(n.getValue(r.autocomplete.field));
            }),
            r.autocomplete.listen('delete', r.newSearch),
            !r.options.countries.value &&
              e.length &&
              (r.options.countries.value = n.getValue(e[0])),
            (r.countrylist = new n.CountryList(e, r.options.countries)),
            (r.countrylist.autocomplete.options.emptyMessage =
              r.messages.NOCOUNTRY),
            (r.country = r.countrylist.country.iso3),
            r.countrylist.listen('change', function (n) {
              (r.country =
                n && n.iso3 ? n.iso3 : r.options.countries.defaultCode),
                r.switchToSearchMode(),
                r.fire('country', n);
            }),
            r.countrylist.autocomplete.listen('filter', function () {
              r.countrylist.autocomplete.list.first();
            }),
            r.countrylist.autocomplete.listen('hide', function () {
              r.autocomplete.enable(),
                r.storedSearch != null &&
                  n.setValue(r.autocomplete.field, r.storedSearch),
                (r.storedSearch = null);
            }),
            r.detectLanguage(),
            (u = n.create('div', { className: 'pcaflagbutton' })),
            (v = r.countrylist.flag()),
            u.appendChild(v),
            r.autocomplete.footer.setContent(
              r.options.bar.showCountry ? u : ''
            ),
            n.listen(u, 'click', r.switchToCountrySelect),
            (f = n.create('div', { className: 'pcaflagbutton' })),
            (y = r.countrylist.flag()),
            f.appendChild(y),
            r.countrylist.autocomplete.footer.setContent(
              r.options.bar.showCountry ? f : ''
            ),
            n.listen(f, 'click', r.switchToSearchMode),
            (l = n.create('div', {
              className: 'pcamessage pcadisableselect',
              innerHTML: r.messages.COUNTRYSELECT,
            })),
            r.autocomplete.footer.setContent(
              r.options.bar.showCountry ? l : ''
            ),
            (i = n.create('a', {
              href:
                r.options.brand == 'CanadaPost'
                  ? 'http://www.canadapost.ca/pca'
                  : 'http://www.pcapredict.com',
              target: '_blank',
              rel: 'nofollow',
            })),
            (s = n.create('div', {
              className:
                r.options.brand == 'None'
                  ? ''
                  : r.options.brand == 'CanadaPost'
                  ? 'aclogo' + (r.languageCode == 'fr' ? 'fr' : 'en')
                  : 'pcalogo',
            })),
            r.options.bar.logoLink ? i.appendChild(s) : (i = s),
            r.autocomplete.footer.setContent(i),
            (r.showFooterLogo = function () {
              i.style.display = r.options.bar.showLogo ? '' : 'none';
            }),
            (r.showFooterMessage = function () {
              i.style.display = r.options.bar.showCountry
                ? 'none'
                : r.options.bar.showLogo
                ? ''
                : 'none';
            }),
            r.options.bar.visible &&
              (r.autocomplete.footer.show(), r.showFooterMessage()),
            (c = n.create('div', {
              className: 'pcamessage pcadisableselect',
              innerHTML: r.messages.COUNTRYSELECT,
            })),
            r.countrylist.autocomplete.footer.setContent(
              r.options.bar.showCountry ? c : ''
            ),
            r.options.bar.visible && r.countrylist.autocomplete.footer.show(),
            r.options.setCountryByIP && r.setCountryByIP(),
            window.setInterval &&
              r.options.prompt &&
              window.setInterval(p, 1e3),
            (r.loaded = !0),
            r.fire('load');
        }),
        (r.searchFromField = function () {
          var t = n.getValue(r.autocomplete.field);
          t &&
            !r.autocomplete.disabled &&
            !r.initialSearch &&
            t.length >= r.options.minSearch &&
            ((r.initialSearch = !0), r.search(t));
        }),
        (r.search = function (t) {
          function i(n) {
            n.length ? r.display(n, r.templates.AUTOCOMPLETE) : u();
          }
          r.lastSuggestion &&
            !~t.indexOf(r.lastSuggestion.Text) &&
            (r.lastSuggestion = null);
          var f = r.lastSuggestion ? r.lastSuggestion.Id || '' : '';
          return (
            r.fire('search', t),
            t &&
              n.fetch(
                r.options.product + '/Interactive/Find/v2.00',
                {
                  Key: r.key,
                  Country: r.country,
                  SearchTerm: t,
                  LastId: f,
                  SearchFor: r.searchMode.EVERYTHING,
                  $block: !0,
                  $cache: !0,
                },
                i,
                r.error
              ),
            r
          );
        }),
        (r.searchByLocation = function (t, i) {
          function s(n) {
            n && n.coords
              ? ((t = n.coords.latitude),
                (i = n.coords.longitude),
                (o = n.coords.accuracy),
                (r.geolocation = n.coords),
                e())
              : f();
          }
          function f() {
            r.message(r.messages.NOLOCATION, !0);
          }
          function e() {
            function f(n) {
              n.length ? r.display(n, r.templates.AUTOCOMPLETE) : u();
            }
            n.fetch(
              r.options.product + '/Interactive/FindByPosition/v2.00',
              {
                Key: r.key,
                Latitude: t,
                Longitude: i,
                LocationAccuracy: o,
                $block: !0,
                $cache: !0,
              },
              f,
              r.error
            );
          }
          var o = 0;
          return (
            (t || t == 0) && (i || i == 0)
              ? e()
              : navigator.geolocation
              ? navigator.geolocation.getCurrentPosition(s, f, {
                  enableHighAccuracy: !0,
                })
              : f(),
            r
          );
        }),
        (r.retrieve = function (t) {
          function f(n) {
            n.length ? r.populate(n) : r.error(r.messages.RETRIEVEERROR);
          }
          for (
            var u = { Key: r.key, Id: t, Source: r.options.source, $cache: !0 },
              i = 0;
            i < r.advancedFields.length;
            i++
          )
            u['field' + (i + 1) + 'format'] = r.advancedFields[i];
          n.fetch(
            r.options.product + '/Interactive/RetrieveFormatted/v2.00',
            u,
            f,
            r.error
          );
        }),
        (r.error = function (n) {
          if ((r.fire('error', n), !r.listeners.error))
            throw r.messages.SERVICEERROR + ' ' + n;
        }),
        (r.display = function (n, t) {
          return (
            r.autocomplete.header.hide(),
            r.highlight(n),
            r.fire('display', n),
            r.autocomplete.clear().add(n, t, r.select).show(),
            r.autocomplete.list.first(),
            r.showFooterLogo(),
            r
          );
        }),
        (r.message = function (n, t) {
          return (
            r.reset(),
            r.autocomplete.show(),
            r.autocomplete.header.setText(n).show(),
            r.showFooterMessage(),
            t && r.autocomplete.clear().list.hide(),
            r
          );
        }),
        (r.prompt = function (n, t) {
          return r.autocomplete.prompt(n, t), r;
        }),
        (r.select = function (t) {
          function i() {
            r.options.setCursor &&
              r.prompt(n.removeHtml(t.Text), t.Cursor >= 0 ? t.Cursor : null),
              (r.lastSuggestion = t),
              r.search(t.Text);
          }
          return (
            r.fire('select', t),
            t.Next == 'Retrieve' ? r.retrieve(t.Id) : i(),
            r
          );
        }),
        (r.highlight = function (n, t, i) {
          var e, r, o, f, u;
          for (t = t || '<b>', i = i || '</b>', e = 0; e < n.length; e++)
            for (
              r = n[e], o = r.Highlight.split(','), f = o.length - 1;
              f >= 0;
              f--
            )
              (u = o[f].split('-')),
                (r.HighlightedText =
                  r.Text.substring(0, parseInt(u[0])) +
                  t +
                  r.Text.substring(parseInt(u[0]), parseInt(u[1])) +
                  i +
                  r.Text.substring(parseInt(u[1]), r.Text.length));
        }),
        (r.populate = function (t) {
          var f = t[0],
            u,
            e,
            i,
            o;
          if (r.options.languagePreference)
            for (u = 0; u < t.length; u++)
              if (t[u].Language == r.options.languagePreference.toUpperCase()) {
                f = t[u];
                break;
              }
          for (
            r.options.countries.prepopulate && r.countrylist.populate(),
              r.fire('prepopulate', f),
              e = 0;
            e < r.fields.length && r.options.populate;
            e++
          )
            ((i = r.fields[e]), i.mode & n.fieldMode.POPULATE) &&
              (!r.options.onlyInputs ||
                n.inputField(i.element) ||
                n.selectList(i.element) ||
                n.checkBox(i.element)) &&
              ((i.mode & n.fieldMode.PRESERVE &&
                n.getValue(i.element) &&
                r.autocomplete.field != n.getElement(i.element)) ||
                ((o =
                  /[\{\}]/.test(i.field) || i.field == ''
                    ? n.formatLine(f, i.field)
                    : f[i.field]),
                n.setValue(i.element, o)));
          return (
            r.autocomplete.hide(), r.newSearch(), r.fire('populate', f, t), r
          );
        }),
        (r.getAddressLine = function (n, t, i, r) {
          var u,
            e = '',
            o,
            s,
            f;
          if (((r = r && !!n.Company), r)) {
            if (t == 1 && i > 1) return n.Company;
            t == 1 && i == 1 ? (e = n.Company) : (t--, i--);
          }
          for (
            u = n.Line1
              ? n.Line2
                ? n.Line3
                  ? n.Line4
                    ? n.Line5
                      ? 5
                      : 4
                    : 3
                  : 2
                : 1
              : 0,
              o = Math.floor(1 + (u / i + (i - (t - 1)) / i) * (t - 1)),
              s = Math.floor(u / i + (i - t) / i),
              f = 0;
            f < s;
            f++
          )
            e += (e ? ', ' : '') + (n['Line' + (f + o)] || '');
          return e;
        }),
        (r.switchToCountrySelect = function () {
          r.countrylist.autocomplete.position(r.autocomplete.field),
            (r.countrylist.autocomplete.field = r.autocomplete.field),
            (r.countrylist.autocomplete.focused = !0),
            r.countrylist.autocomplete.showAll(),
            r.countrylist.autocomplete.list.first(),
            r.autocomplete.disable().hide(),
            (r.storedSearch = n.getValue(r.autocomplete.field)),
            n.clear(r.autocomplete.field),
            r.autocomplete.field.focus();
        }),
        (r.switchToSearchMode = function () {
          var n = r.storedSearch != null;
          r.autocomplete.enable(),
            r.countrylist.autocomplete.hide(),
            n &&
              (r.newSearch(),
              r.autocomplete.field.focus(),
              r.searchFromField());
        }),
        (r.setCountry = function (n) {
          return r.countrylist.setCountry(n), r;
        }),
        (r.setCountryByIP = function () {
          return r.countrylist.setCountryByIP(r.key), r;
        }),
        (r.detectLanguage = function () {
          if (
            window &&
            window.navigator &&
            (window.navigator.language ||
              window.navigator.browserLanguage ||
              r.options.culture)
          ) {
            var n =
              r.options.culture ||
              window.navigator.language ||
              window.navigator.browserLanguage;
            (r.languageCode =
              n && n.length > 1 ? n.substring(0, 2).toLowerCase() : 'en'),
              r.translations[r.languageCode] &&
                (r.messages = r.translations[r.languageCode]);
          }
        }),
        (r.setCulture = function (n) {
          (r.options.culture = n), r.reload();
        }),
        (r.setWidth = function (n) {
          r.autocomplete.setWidth(n), r.countrylist.autocomplete.setWidth(n);
        }),
        (r.setHeight = function (n) {
          r.autocomplete.setHeight(n), r.countrylist.autocomplete.setHeight(n);
        }),
        (r.clear = function () {
          for (var t = 0; t < r.fields.length; t++)
            n.setValue(r.fields[t].element, '');
          return r.fire('clear'), r;
        }),
        (r.reset = function () {
          return (
            r.options.bar.visible
              ? (r.autocomplete.list.clear().hide(),
                r.autocomplete.header.hide(),
                r.showFooterMessage(),
                r.autocomplete.reposition())
              : (r.autocomplete.hide(), r.autocomplete.footer.hide()),
            r.newSearch(),
            r
          );
        }),
        (r.newSearch = function () {
          (r.initialSearch = !1), (r.lastActionTime = null);
        }),
        (r.focus = function () {
          r.reset(),
            r.options.autoSearch && r.searchFromField(),
            r.fire('focus');
        }),
        (r.blur = function () {
          (r.countrylist.autocomplete.field = null),
            (r.countrylist.autocomplete.focused = !1),
            r.countrylist.autocomplete.checkHide(),
            r.fire('blur');
        }),
        (r.hide = function () {
          r.autocomplete.hide(), r.countrylist.autocomplete.hide();
        }),
        (r.disable = function () {
          return (
            (r.autocomplete.disabled = !0),
            (r.countrylist.autocomplete.disabled = !0),
            r
          );
        }),
        (r.enable = function () {
          return (
            (r.autocomplete.disabled = !1),
            (r.countrylist.autocomplete.disabled = !1),
            r
          );
        }),
        (r.destroy = function () {
          return (
            r.autocomplete.destroy(), r.countrylist.autocomplete.destroy(), r
          );
        }),
        (r.reload = function () {
          r.destroy(), r.load();
        }),
        (r.manualEntry = function () {
          return (
            window &&
              window.setTimeout &&
              r.options.disableTime &&
              (r.autocomplete.field.focus(),
              r.destroy(),
              window.setTimeout(r.load, r.options.disableTime),
              r.fire('manual')),
            r
          );
        }),
        (r.bound = function (i) {
          if ((i = n.getElement(i)))
            for (var u = 0; u < r.fields.length; u++)
              if (i == n.getElement(t[u].element)) return !0;
          return !1;
        }),
        n.ready(r.load);
    });
})();
(function () {
  (pca.AddressComplete = function () {
    function i(t) {
      return (
        (t = t || {}),
        (t.countries = t.countries || {}),
        t.AddressCompleteCountryByIP &&
          (t.setCountryByIP = t.AddressCompleteCountryByIP),
        t.AddressCompleteDefaultLanguage &&
          (t.culture = t.AddressCompleteDefaultLanguage),
        t.AddressCompleteDefaultCountry &&
          (t.countries.defaultCode = t.AddressCompleteDefaultCountry),
        t.AddressCompleteCountryList &&
          (t.countries.codesList = t.AddressCompleteCountryList),
        (t.suppressAutocomplete = !0),
        (t.prompt = !0),
        n.fire('options', t),
        t
      );
    }
    function t(n) {
      function t() {
        typeof AddressCompleteLoaded != 'undefined' && AddressCompleteLoaded(n);
      }
      n.listen('load', t),
        n.loaded && t(),
        n.listen('populate', function (t, i) {
          typeof AddressCompleteCallback != 'undefined' &&
            AddressCompleteCallback(n, t, i);
        }),
        n.listen('error', function (t) {
          typeof AddressCompleteError != 'undefined' &&
            AddressCompleteError(n, t);
        });
    }
    var n = new pca.Eventable(this);
    (n.controls = []),
      (n.bindings = []),
      (n.load = function () {
        var r, u;
        for (n.destroy(), r = 0; r < n.bindings.length; r++)
          (u = new pca.Address(n.bindings[r].fields, i(n.bindings[r].options))),
            t(u),
            n.controls.push(u),
            n.fire('load', u);
        n.fire('ready');
      }),
      (n.all = function (t) {
        for (var i = 0; i < n.controls.length; i++) t(n.controls[i]);
      }),
      (n.setCulture = function (t) {
        n.all(function (n) {
          n.setCulture(t);
        });
      }),
      (n.setCountry = function (t) {
        n.all(function (n) {
          n.setCountry(t);
        });
      }),
      (n.setWidth = function (t) {
        n.all(function (n) {
          n.setWidth(t);
        });
      }),
      (n.setHeight = function (t) {
        n.all(function (n) {
          n.setHeight(t);
        });
      }),
      (n.enable = function () {
        n.all(function (n) {
          n.enable();
        });
      }),
      (n.disable = function () {
        n.all(function (n) {
          n.disable();
        });
      }),
      (n.destroy = function () {
        n.all(function (n) {
          n.destroy();
        }),
          (n.controls = []);
      }),
      pca.ready(n.load);
  }),
    (window.addressComplete = pca.addressComplete = new pca.AddressComplete());
})();
